import { DatePipe, DecimalPipe } from '@angular/common';
import { Component, Input, ViewChild, ElementRef} from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService, ConfirmEventType } from 'primeng/api';
import { parse } from 'url';
import { BookingInfoProperties, BookingPassengerInfoProperties, SectorInformationProperties, TaxDetailsProperties, RemovePassengerData, MealAirArabiaProperties, UpdatePriceDetails } from '../Models/BookingPassengerTicketIssuanceProperties';
import { Countries } from '../Models/Countries';
import { FlightSearchService } from "../Services/FlightSearch.service";
import { PassengerInfoService } from '../Services/passengerInfo.service';
import { ModalDismissReasons, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

import { PassengerProfile, ModifyDataCarry } from '../Models/BookingPassengerTicketIssuanceProperties';
import { FlyDubaiAnxiResponse, FlyDubaiAnxiHandling } from '../Models/TicketIssuanceProperties';
import { AirSegmentsDetails, FlightSearchProperties, PriceCardDetails } from '../Models/FlightSearchProperties';
import { PassengerFares } from '../Models/FlightSearchResponseProperties';
import { Bind } from 'primeng/bind';
import { Dialog } from 'primeng/dialog';
import { FormsModule } from '@angular/forms';
import { DxDataGridModule } from 'devextreme-angular';
import { DxoSelectionModule, DxoPagingModule, DxoFilterRowModule, DxiColumnModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
declare var $;
@Component({
    selector: 'app-flydubai-modify',
    templateUrl: './flydubai-modify.component.html',
    styleUrls: ['./flydubai-modify.component.css'],
    providers: [ConfirmationService, MessageService],
    imports: [Bind, Dialog, FormsModule, DxDataGridModule, DxoSelectionModule, DxoPagingModule, DxoFilterRowModule, DxiColumnModule, DxTemplateModule, NgSelectModule, DecimalPipe]
})

/** ModifyPassengerInfo component*/
export class FlyDubaiModifyComponent {
  @ViewChild('delete', { static: true }) deleteModal!: ElementRef;
  ModifyData: any;
  RemovePass: boolean = false;
  /** ModifyPassengerInfo ctor */
  bookingInfo = new BookingInfoProperties();
  dataFormSubmit: boolean = false;
  @Input()
  pattern: string | RegExp;
  countryList: Countries[] | undefined;
  date;
  dob: boolean[] = [false];
  AdultQuantity: number = 0;
  AdultDisable: boolean = false;
  ChildQuantity: number = 0;
  ChildDisable: boolean = false;
  InfantQuantity: number = 0;
  InfantDisable: boolean = false;
  seatcheck: boolean = false;
  obj = new BookingPassengerInfoProperties();
  sectorObj = new SectorInformationProperties();
  taxObj = new TaxDetailsProperties();
  removePsngrObj = new RemovePassengerData();
  updatePassengerObj = new UpdatePriceDetails();
  //BookingPassengerInfoProperties;
  RemovePassengerInfo: BookingPassengerInfoProperties[] = [];
  constructor(private router: Router, public psService: PassengerInfoService, private confirmationService: ConfirmationService, private flightService: FlightSearchService,
    private messageService: MessageService, public userService: PassengerInfoService, private modalService: NgbModal, private NewSuccess: NgbModal,  private FallSuccess: NgbModal) {

  }
  ngOnInit() {
    this.priceCardDetails = [];
    this.totalBasePriceConv = this.currency + 0;
    this.totalTaxesConv = this.currency + 0;
    this.totalPriceConv = this.currency + 0;
    this.totalDiscountConv = this.currency + 0;
    this.totalServiceFeeConv = this.currency + 0;
   this.totalBasePrice = 0;
   this.totalTaxes=0;
   this.totalPrice=0;
   this.totalDiscount=0;
    this.totalServiceFee=0;

    this.bookingInfo = JSON.parse(localStorage.getItem("flightmodifyPassengerInfo"));
    this.ProcessSegments();
    this.getCountries();
    this.date = new Date().toISOString().slice(0, 10);
  }


  OrigionalData: ModifyDataCarry;
  openModalOnInit() {
    // Open the modal when component initializes
    this.modalService.open(this.deleteModal, { centered: true }); // Open the modal
  }

  CommitModifyRequest(modifyType: string) {
    if (modifyType) {
      this.modalService.dismissAll();
      this.modifyBooking = true;
      this.flightService.CommitModifyRequest(this.OrigionalData).subscribe((data) => {
        if (data) {
          this.modifyBooking = false;
          var bookingid = data.bookingID;
          localStorage.setItem("bookingID", String(bookingid));
          this.router.navigateByUrl('/ticket-issuance');
        }

      });
    }
  }




  getCountries() {
    try {
      this.userService.getCountries().subscribe((data) => {
        this.countryList = data;

      });
    }
    catch (e) {
      console.log(e);
    }
  }
  modifyBooking: boolean = false;
  cancel() {
    this.confirmationService.confirm({
      message: 'Do you want to Cancel this Modification?',
      header: 'Cancel Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.messageService.add({ severity: 'info', summary: 'Confirmed', detail: 'Modification cancelled' });
        this.router.navigateByUrl('/ticket-issuance');
      },
      reject: (type: ConfirmEventType) => {
        switch (type) {
                    case ConfirmEventType.REJECT:
      this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'Now You Edit the Passenger Info' });
      break;
      
    }
  }
});
  }
  passengerSelected: boolean = false;



  RemovePassenger(type: string) {
    if (type == "Adult") {
      this.AdultQuantity = this.AdultQuantity - 1;
      
    } else if (type == "Child") {
      this.ChildQuantity = this.ChildQuantity - 1;
      
    } else if (type == "Infant") {
      this.InfantQuantity = this.InfantQuantity - 1;
     
    }

  }
  AddPassenger(type: string) {

    if (type == "Adult") {
      if (this.AdultQuantity + this.ChildQuantity >= 9) {
        this.AdultDisable = true;
      }
      this.AdultQuantity = this.AdultQuantity + 1;
      
    } else if (type == "Child") {
      if (this.AdultQuantity + this.ChildQuantity >= 9) {
        this.ChildDisable = true;
      }
      this.ChildQuantity = this.ChildQuantity + 1;
      
    }else if (type == "Infant") {
      this.InfantQuantity = this.InfantQuantity + 1;
     
    }


  }
  ConfirmationPrice: boolean = false;
  SubmitAddPassenger() {
    this.modifyBooking = true;
    this.flightService.SubmitAddPassenger(this.bookingInfo).subscribe((data) => {
      //this.isLoadPanelVisible = false;
      this.modifyBooking = false;
      if (data) {
        //this.updatePassengerObj = data;
        //this.ConfirmationPrice = true;
        //this.flyDubaiAnxillaryProcessing(data);

      }
    });
  }

  AddPax: boolean = false;
  TakePassengersDetails() {
    this.AddPax = true;
    this.bookingInfo.galileoBookingProp.flightProp.adultModify = this.AdultQuantity;
    this.bookingInfo.galileoBookingProp.flightProp.childModify = this.ChildQuantity;
    this.bookingInfo.galileoBookingProp.flightProp.infantModify = this.InfantQuantity;

    if (this.bookingInfo.galileoBookingProp.flightProp.adultModify > 0) {
      for (let i = 0; i < this.bookingInfo.galileoBookingProp.flightProp.adultModify; i++) {
        this.obj = new BookingPassengerInfoProperties();
        this.obj.passengerType = 1;
        let date = Date.now();
        let dateStr = String(date);
        let slicedDate = dateStr.slice(7);
        let PAX = 1;
        this.obj.passengerID = Number(slicedDate + PAX + i);
        for (let j = 0; j < this.bookingInfo.bookingPassengerInfoProperties[0].sectorInformationProperties.length;j++) {
           this.obj.sectorInformationProperties.push(this.sectorObj);
        }
        this.obj.taxDetailsProperties.push(this.taxObj);
        this.bookingInfo.exchangebookingPassengerInfoProperties.push(this.obj);
        //this.sectorObj = new SectorInformationProperties();
        //this.taxObj = new TaxDetailsProperties();
        //this.obj = new BookingPassengerInfoProperties();
      }
    }
    if (this.bookingInfo.galileoBookingProp.flightProp.childModify > 0) {
      for (let i = 0; i < this.bookingInfo.galileoBookingProp.flightProp.childModify; i++) {
        this.obj = new BookingPassengerInfoProperties();
      this.obj.passengerType = 2; //
      let date = Date.now();
      let dateStr = String(date);
      let slicedDate = dateStr.slice(7);
      let PAX = 2;
      this.obj.passengerID = Number(slicedDate + PAX + i);
        for (let j = 0; j < this.bookingInfo.bookingPassengerInfoProperties[0].sectorInformationProperties.length; j++) {
          this.obj.sectorInformationProperties.push(this.sectorObj);
        }
      this.obj.taxDetailsProperties.push(this.taxObj);
      this.bookingInfo.exchangebookingPassengerInfoProperties.push(this.obj);
      //this.sectorObj = new SectorInformationProperties();
      //this.taxObj = new TaxDetailsProperties();
      //this.obj = new BookingPassengerInfoProperties();
      }
    }
    if (this.bookingInfo.galileoBookingProp.flightProp.infantModify > 0) { 
      for (let i = 0; i < this.bookingInfo.galileoBookingProp.flightProp.infantModify; i++) {
        this.obj = new BookingPassengerInfoProperties();
      this.obj.passengerType = 3; //
      let date = Date.now();
      let dateStr = String(date);
      let slicedDate = dateStr.slice(7);
      let PAX = 3;
      this.obj.passengerID = Number(slicedDate + PAX + i);
        for (let j = 0; j < this.bookingInfo.bookingPassengerInfoProperties[0].sectorInformationProperties.length; j++) {
          this.obj.sectorInformationProperties.push(this.sectorObj);
        }
      this.obj.taxDetailsProperties.push(this.taxObj);
        this.bookingInfo.exchangebookingPassengerInfoProperties.push(this.obj);
      //this.sectorObj = new SectorInformationProperties();
      //this.taxObj = new TaxDetailsProperties();
      //this.obj = new BookingPassengerInfoProperties();

    }
    }

    //var hid = document.querySelector('.tttt') as HTMLDivElement;
    //hid.classList.remove("adpxV");


  }
  MobileNumberValidateWhenSearch(i) {

    var mobile = document.getElementById(`mobilenumbervalidate${i}`) as HTMLInputElement;

    /* var pattern = "@^(\+\d{1,2})?\(?\d{3}\)?\d{3}\d{4}$@";*/
    var pattern = /^\+\d{3}?\d+$/;
    if (mobile.value.match(pattern)) {

      document.getElementById(`messagepass${i}`).innerHTML = '';
      this.validatepass = true;
    }
    else {

      document.getElementById(`messagepass${i}`).innerHTML = 'Please Follow the Pattern of Mobile Number';
      this.validatepass = false;
    }
    return this.validatepass;
  }
  ctc_num: string;
  valid = true;
  validatepass = true;
  searchprofileCred: PassengerProfile[];
  SearchCtcNo(targetmodel, ctc, i) {
    this.ctc_num = ctc;
    var ctc_number = { ctcno: this.ctc_num }
    if (this.MobileNumberValidateWhenSearch(i) == false) {
      return;
    }
    try {

      this.userService.GetPassengerProfileSearch(ctc_number).subscribe((data) => {


        let Searchpassenger = [];
        /* this.searchprofileCred = data;*/

        Searchpassenger = data;
        for (let i = 0; i < Searchpassenger.length; i++) {
          if (Searchpassenger[i].passengerType == 1) {
            Searchpassenger[i].passengerTypeName = "Adult";
          }
          else if (Searchpassenger[i].passengerType == 2) {
            Searchpassenger[i].passengerTypeName = "Child";
          }
          else if (Searchpassenger[i].passengerType == 3) {
            Searchpassenger[i].passengerTypeName = "Infant";
          }
        }
        this.searchprofileCred = Searchpassenger;
        for (let j = 0; j < this.searchprofileCred.length; j++) {
          this.searchprofileCred[j].passengerindex = i;
        }
        //console.log(this.searchprofileCred.passengerindex);
        if (this.searchprofileCred.length > 0) {
          this.modalService.open(targetmodel, {

            /*          windowClass: "searchpassengerpopupmodal"*/
            //scrollable: true,
            //size: 'modal-xl',
            size: 'lg',
          })
        }

        //console.log(data);

      });
    }
    catch (e) {
      console.log(e);
    }

  }


  Select_Profiledata(data, targetmodel) {
    try {

      var index = this.searchprofileCred[0].passengerindex;

      for (let i = 0; i < this.bookingInfo.exchangebookingPassengerInfoProperties.length; i++) {

        if (index == i) {


          this.bookingInfo.exchangebookingPassengerInfoProperties[i].profile_Id = data.profile_Id,
            this.bookingInfo.exchangebookingPassengerInfoProperties[i].title = data.title,

            this.bookingInfo.exchangebookingPassengerInfoProperties[i].firstName = data.firstName,
            this.bookingInfo.exchangebookingPassengerInfoProperties[i].lastName = data.lastName,
            this.bookingInfo.exchangebookingPassengerInfoProperties[i].paxGender = data.paxGender,
            this.bookingInfo.exchangebookingPassengerInfoProperties[i].paxdob = data.paxDOB,
            this.bookingInfo.exchangebookingPassengerInfoProperties[i].mobile = data.mobile_No,
            /* this.bookingObj.bookingPassengerInfoProperties[i].phone = data.phone_No,*/
            this.bookingInfo.exchangebookingPassengerInfoProperties[i].paxNationality = data.paxNationality,
            /* this.bookingObj.bookingPassengerInfoProperties[i].passportValidFrom= data.passportValidFrom,*/
            this.bookingInfo.exchangebookingPassengerInfoProperties[i].passportValidTo = data.passportValidTo,
            this.bookingInfo.exchangebookingPassengerInfoProperties[i].passportNumber = data.passportNumber,
            this.bookingInfo.exchangebookingPassengerInfoProperties[i].countryOfIssuance = data.countryOfIssuance,
            this.bookingInfo.exchangebookingPassengerInfoProperties[i].email = data.email_Id,
            this.bookingInfo.exchangebookingPassengerInfoProperties[i].frequent_Flyer_No = data.frequent_Flyer_No,

            //this.mobile = data.mobile_No;
            //this.email = data.email_Id;
            //this.phone = data.phone_No;
            //console.log(this.bookingObj.bookingPassengerInfoProperties);


            this.modalService.dismissAll(targetmodel);
        }
      }
    }

    catch (e) { console.log(e); }
  }
  getSearchonfocusout(targetmodel, ctc, i) {
    this.ctc_num = ctc;
    var ctc_number = { ctcno: this.ctc_num }
    if (this.MobileNumberValidateWhenSearch(i) == false) {
      return;
    }
    try {

      this.userService.GetPassengerProfileSearch(ctc_number).subscribe((data) => {

        let Searchpassenger = [];
        /* this.searchprofileCred = data;*/

        Searchpassenger = data;
        for (let i = 0; i < Searchpassenger.length; i++) {
          if (Searchpassenger[i].passengerType == 1) {
            Searchpassenger[i].passengerTypeName = "Adult";
          }
          else if (Searchpassenger[i].passengerType == 2) {
            Searchpassenger[i].passengerTypeName = "Child";
          }
          else if (Searchpassenger[i].passengerType == 3) {
            Searchpassenger[i].passengerTypeName = "Infant";
          }
        }
        this.searchprofileCred = Searchpassenger;
        for (let j = 0; j < this.searchprofileCred.length; j++) {
          this.searchprofileCred[j].passengerindex = i;
        }

        if (this.searchprofileCred.length > 0) {
          this.modalService.open(targetmodel, {

            /*   windowClass: "searchpassengerpopupmodal"*/
            //scrollable: true,
            size: 'lg',
          })
        }


      });
    }
    catch (e) {
      console.log(e);
    }

  }

  //genderSelectonGivenTitle(i) {
  //  var title = document.getElementById(`titles${i}`) as HTMLSelectElement;


  //  if (title.value == "Mstr") {
  //    var gender = document.getElementById(`male${i}`) as HTMLSelectElement;
  //    this.bookingInfo.exchangebookingPassengerInfoProperties[i].paxGender = gender.value;
  //  }
  //  else if (title.value == "Mr") {
  //    var gender = document.getElementById(`male${i}`) as HTMLSelectElement;
  //    this.bookingInfo.exchangebookingPassengerInfoProperties[i].paxGender = gender.value;
  //  }
  //  else if (title.value == "Ms") {
  //    var gender = document.getElementById(`female${i}`) as HTMLSelectElement;
  //    this.bookingInfo.exchangebookingPassengerInfoProperties[i].paxGender = gender.value;
  //  }
  //  else if (title.value == "Miss") {
  //    var gender = document.getElementById(`female${i}`) as HTMLSelectElement;
  //    this.bookingInfo.exchangebookingPassengerInfoProperties[i].paxGender = gender.value;
  //  }
  //  else if (title.value == "Mrs") {
  //    var gender = document.getElementById(`female${i}`) as HTMLSelectElement;
  //    this.bookingInfo.exchangebookingPassengerInfoProperties[i].paxGender = gender.value;
  //  }

  //}


  RemovePassengerPop() {
    this.ngOnInit();
    this.RemovePassengerInfo = [];
    this.NewSuccess.dismissAll();

    for (let j = 0; j < this.bookingInfo.bookingPassengerInfoProperties.length; j++) {
/*      if (!this.bookingInfo.bookingPassengerInfoProperties[j].paxRemFrmBkng) {*/
          this.RemovePassengerInfo.push(this.bookingInfo.bookingPassengerInfoProperties[j]);
        /*}*/
    }
    this.RemovePass = true;
      //if (this.RemovePassengerInfo.length > 0) {
      //  $("#myModalRemoveP").modal('show');
      //}
    
  }

  Removecheckpassenger(j) {
    if (this.bookingInfo.providerCode == "HITIT" || this.bookingInfo.providerCode == "FZ"){
      if (this.RemovePassengerInfo[j].paxRemFrmBkng) {
        if (this.RemovePassengerInfo[j].passengerType == 1) {
          for (let k = 0; k < this.RemovePassengerInfo.length; k++) {
            if (this.RemovePassengerInfo[j].firstName == this.RemovePassengerInfo[k].associatedAdult) {
              if (!this.RemovePassengerInfo[k].paxRemFrmBkng) {
                this.RemovePassengerInfo[k].paxRemFrmBkng = true;
                break;
              }
            }
          }
        }
        if (this.RemovePassengerInfo[j].passengerType == 3) {
          for (let k = 0; k < this.RemovePassengerInfo.length; k++) {
            if (this.RemovePassengerInfo[j].associatedAdult == this.RemovePassengerInfo[k].firstName) {
              if (!this.RemovePassengerInfo[k].paxRemFrmBkng) {
                this.RemovePassengerInfo[k].paxRemFrmBkng = true;
                break;
              }
            }
          }
        }
      }
      else {
        if (!this.RemovePassengerInfo[j].paxRemFrmBkng) {
          if (this.RemovePassengerInfo[j].passengerType == 1) {
            for (let k = 0; k < this.RemovePassengerInfo.length; k++) {
              if (this.RemovePassengerInfo[j].firstName == this.RemovePassengerInfo[k].associatedAdult) {
                if (this.RemovePassengerInfo[k].paxRemFrmBkng) {
                  this.RemovePassengerInfo[k].paxRemFrmBkng = false;
                  break;
                }
              }
            }
          }
          if (this.RemovePassengerInfo[j].passengerType == 3) {
            for (let k = 0; k < this.RemovePassengerInfo.length; k++) {
              if (this.RemovePassengerInfo[j].associatedAdult == this.RemovePassengerInfo[k].firstName) {
                if (this.RemovePassengerInfo[k].paxRemFrmBkng) {
                  this.RemovePassengerInfo[k].paxRemFrmBkng = false;
                  break;
                }
              }
            }
          }

        }
      }
    }
    else if (this.bookingInfo.providerCode == "FZ") {
      let countofrem = 0;
      for (let k = 0; k < this.RemovePassengerInfo.length; k++) {
        if (this.RemovePassengerInfo[k].paxRemFrmBkng) {
         countofrem++;
       }
   
      }
      
      if (countofrem == this.bookingInfo.bookingPassengerInfoProperties.length) {
        document.getElementById("voidrequiredmsg").innerHTML = "Only Some Passengers are Allowed to Remove.";
      }
      else {
        document.getElementById("voidrequiredmsg").innerHTML = "";
      }
      

    }
  }


  RmvPassengerFrmBooking() {
    let adultTotal = this.bookingInfo.galileoBookingProp.flightProp.adult;
    let childTotal = this.bookingInfo.galileoBookingProp.flightProp.child;
    let infantTotal = this.bookingInfo.galileoBookingProp.flightProp.infant;
    let TotalPassengers = this.bookingInfo.galileoBookingProp.flightProp.adult + this.bookingInfo.galileoBookingProp.flightProp.child+ this.bookingInfo.galileoBookingProp.flightProp.infant;
    let countofrem = 0;
    let adultCount = 0;
    let childCount = 0;
    let infantCount = 0;
    for (let k = 0; k < this.RemovePassengerInfo.length; k++) {
      if (this.RemovePassengerInfo[k].paxRemFrmBkng) {
        countofrem++;
      }
      if (this.RemovePassengerInfo[k].paxRemFrmBkng && this.RemovePassengerInfo[k].passengerType == 1) {
        adultCount++;
      }
      if (this.RemovePassengerInfo[k].paxRemFrmBkng && this.RemovePassengerInfo[k].passengerType == 2) {
        childCount++;
      }
      if (this.RemovePassengerInfo[k].paxRemFrmBkng && this.RemovePassengerInfo[k].passengerType == 3) {
        infantCount++;
      }
    }
    if (adultCount == adultTotal && TotalPassengers > countofrem) {
      document.getElementById("voidrequiredmsg").innerHTML = "All Primary passenger are not allowed to Remove.";
      return;
    }
    if (adultTotal == adultCount && countofrem == adultCount) {
      document.getElementById("voidrequiredmsg").innerHTML = "All adults are not allowed to Remove.";
      return;
    }
    else if (countofrem == this.bookingInfo.bookingPassengerInfoProperties.length) {
      document.getElementById("voidrequiredmsg").innerHTML = "Only Some Passengers are Allowed to Remove.";
      return;
    }
    else {
      document.getElementById("voidrequiredmsg").innerHTML = "";
    }


  
    this.removePsngrObj.BookingInfoProperties = this.bookingInfo;

    this.removePsngrObj.RemovebookingPassengerInfo = this.RemovePassengerInfo;
    for (let u = 0; u < this.bookingInfo.bookingPassengerInfoProperties.length; u++) {

      for (let t = 0; t < this.RemovePassengerInfo.length; t++) {
        if (this.bookingInfo.bookingPassengerInfoProperties[u].firstName + this.bookingInfo.bookingPassengerInfoProperties[u].lastName ==
          this.RemovePassengerInfo[t].firstName + this.RemovePassengerInfo[t].lastName) {
          this.bookingInfo.bookingPassengerInfoProperties[u] = this.RemovePassengerInfo[t];
          break;
        }
      }
    }
    this.RemovePass = false;
    this.modifyBooking = true;

    this.flightService.RmvPassengerFrmBooking(this.bookingInfo).subscribe((data) => {
      this.modifyBooking = false;
      //this.isLoadPanelVisible = false;
      if (data) {
        this.OrigionalData = data;
        console.log(this.OrigionalData);
        //let modifyyyyy = JSON.parse(JSON.stringify(data.ModifyCarry));
        this.ModifyData = JSON.parse(JSON.stringify(JSON.parse(data.modifyCarry)));
        this.openModalOnInit();



      }
      else {

      }
    });

  }


  //RmvPassengerFrmBooking() {

  //  this.removePsngrObj.BookingInfoProperties = this.bookingInfo;
  //  this.removePsngrObj.RemovebookingPassengerInfo = this.RemovePassengerInfo;
  //  for (let u = 0; u < this.bookingInfo.bookingPassengerInfoProperties.length; u++) {

  //    for (let t = 0; t < this.RemovePassengerInfo.length; t++) {
  //      if (this.bookingInfo.bookingPassengerInfoProperties[u].firstName + this.bookingInfo.bookingPassengerInfoProperties[u].lastName ==
  //        this.RemovePassengerInfo[t].firstName + this.RemovePassengerInfo[t].lastName) {
  //        this.bookingInfo.bookingPassengerInfoProperties[u] = this.RemovePassengerInfo[t];
  //        break;
  //      }
  //    }
  //  }


  //  this.flightService.RmvPassengerFrmBooking(this.bookingInfo).subscribe((data) => {
  //    //this.isLoadPanelVisible = false;
  //    if (data) {

  //      var bookingid = data.bookingID;
  //      localStorage.setItem("bookingID", String(bookingid));
  //      this.router.navigateByUrl('/ticket-issuance');

  //    }
  //    else {

  //    }
  //  });




  //}

  mealPersonIndex: number = 0;
  mealSectorIndex: number = 0;
  mealListIndex: number = 0;
  mealIndex: number = 0;
  fzMealArray: any;
  fzBaggageArray: any;
  //fzMealSelect(indexI, indexF, indexM, indexQ) {
  //  try {
  //    if (indexI == this.mealPersonIndex && this.mealSectorIndex == indexF) {


  //      document.getElementById(`mealselectid${this.mealPersonIndex}${this.mealSectorIndex}${this.mealListIndex}`).innerHTML = "Select";
  //      document.getElementById(`mealselectbtn${this.mealPersonIndex}${this.mealSectorIndex}${this.mealListIndex}`).style.backgroundColor = "#39454B";
  //      document.getElementById(`mealselectbtn${this.mealPersonIndex}${this.mealSectorIndex}${this.mealListIndex}`).style.borderColor = "#39454B";
  //    }
  //  }
  //  catch (e) {

  //  }
  //  try {
  //    document.getElementById(`mealselectid${indexI}${indexF}${indexM}${indexQ}`).innerHTML = "Selected";
  //    document.getElementById(`mealselectbtn${indexI}${indexF}${indexM}${indexQ}`).style.borderColor = "var(--first-color-second)";
  //    document.getElementById(`mealselectbtn${indexI}${indexF}${indexM}${indexQ}`).style.backgroundColor = "var(--first-color-second)";
  //  }
  //  catch (e) {

  //  }
  //  this.mealPersonIndex = indexI;
  //  this.mealSectorIndex = indexF;
  //  this.mealListIndex = indexM;
  //  //this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].mealname = this.fzMealArray[indexM].mealName
  //  if (this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].mealFee) {
  //    let passtype = "";
  //    if (this.bookingInfo.bookingPassengerInfoProperties[indexI].passengerType == 1) {
  //      passtype = "Adult";
  //    }
  //    else if (this.bookingInfo.bookingPassengerInfoProperties[indexI].passengerType == 2) {
  //      passtype = "Child";
  //    }
  //    //updating the meal fee of respective custimer
  //    for (let v = 0; v < this.priceCardDetails.length; v++) {
  //      let mealFeeCalcu = 0;
  //      if (this.priceCardDetails[v].passengerType == passtype) {
  //        mealFeeCalcu = Number(this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].mealFee);
  //        mealFeeCalcu = Number(this.priceCardDetails[v].mealFee.slice(3)) - mealFeeCalcu;
  //        this.priceCardDetails[v].mealFee = this.currency + mealFeeCalcu;
  //      }
  //    }

  //    this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].mealname = this.fzMealArray[indexM][indexQ].description;
  //    this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].mealFee = this.fzMealArray[indexM][indexQ].amount * this.bookingInfo.passengerFares[0].currencyRate;
  //    this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].meal = this.fzMealArray[indexM][indexQ].code;
  //    //this.priceCardDMealUpdation(indexI, indexF);



  //  } else {
  //    this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].mealname = this.fzMealArray[indexM][indexQ].description;
  //    this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].mealFee = this.fzMealArray[indexM][indexQ].amount * this.bookingInfo.passengerFares[0].currencyRate;
  //    this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].meal = this.fzMealArray[indexM][indexQ].code;
  //    //this.priceCardDMealUpdation(indexI, indexF);
  //  }

  //  setTimeout(() => {
  //    document.querySelector("#fz-meal-container" + indexI + indexF).classList.add("meal-no");
  //  }, 2000)
  //  console.log(indexI, indexF);
  //  console.log(this.bookingInfo.bookingPassengerInfoProperties[indexI])
  //}



  fzMealSelect(indexI, indexF, indexM, indexQ) {
    try {
      if (indexI == this.mealPersonIndex && this.mealSectorIndex == indexF) {


        document.getElementById(`mealselectid${this.mealPersonIndex}${this.mealSectorIndex}${this.mealListIndex}${this.mealIndex}`).innerHTML = "Select";
        document.getElementById(`mealselectbtn${this.mealPersonIndex}${this.mealSectorIndex}${this.mealListIndex}${this.mealIndex}`).style.backgroundColor = "#39454B";
        document.getElementById(`mealselectbtn${this.mealPersonIndex}${this.mealSectorIndex}${this.mealListIndex}${this.mealIndex}`).style.borderColor = "#39454B";
      }
    }
    catch (e) {

    }
    try {
      document.getElementById(`mealselectid${indexI}${indexF}${indexM}${indexQ}`).innerHTML = "Selected";
      document.getElementById(`mealselectbtn${indexI}${indexF}${indexM}${indexQ}`).style.borderColor = "var(--first-color-second)";
      document.getElementById(`mealselectbtn${indexI}${indexF}${indexM}${indexQ}`).style.backgroundColor = "var(--first-color-second)";
    }
    catch (e) {

    }
    this.mealPersonIndex = indexI;
    this.mealSectorIndex = indexF;
    this.mealListIndex = indexM;
    this.mealIndex = indexQ;
    //this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].mealname = this.fzMealArray[indexM].mealName
    if (this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].mealFee) {
      let passtype = "";
      if (this.bookingInfo.bookingPassengerInfoProperties[indexI].passengerType == 1) {
        passtype = "Adult";
      }
      else if (this.bookingInfo.bookingPassengerInfoProperties[indexI].passengerType == 2) {
        passtype = "Child";
      }
      //updating the meal fee of respective custimer
      for (let v = 0; v < this.priceCardDetails.length; v++) {
        let mealFeeCalcu = 0;
        if (this.priceCardDetails[v].passengerType == passtype) {
          mealFeeCalcu = Number(this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].mealFee);
          mealFeeCalcu = Number(this.priceCardDetails[v].mealFee.slice(3)) - mealFeeCalcu;
          this.priceCardDetails[v].mealFee = this.currency + mealFeeCalcu;
        }
      }

      this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].mealname = this.fzMealArray[indexM][indexQ].description;
      this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].mealFee = this.fzMealArray[indexM][indexQ].amount * this.bookingInfo.passengerFares[0].currencyRate;
      this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].meal = this.fzMealArray[indexM][indexQ].code;
      this.priceCardDMealUpdation(indexI, indexF);



    } else {
      this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].mealname = this.fzMealArray[indexM][indexQ].description;
      this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].mealFee = this.fzMealArray[indexM][indexQ].amount * this.bookingInfo.passengerFares[0].currencyRate;
      this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].meal = this.fzMealArray[indexM][indexQ].code;
      this.priceCardDMealUpdation(indexI, indexF);
    }




    setTimeout(() => {
      document.querySelector("#fz-meal-container" + indexI + indexF).classList.add("meal-no");
    }, 2000)
    console.log(indexI, indexF);
    console.log(this.bookingInfo.bookingPassengerInfoProperties[indexI])
  }


  priceCardDMealUpdation(indexI, indexF) {
    let passtype = "";
    if (this.bookingInfo.bookingPassengerInfoProperties[indexI].passengerType == 1) {
      passtype = "Adult";
    }
    else if (this.bookingInfo.bookingPassengerInfoProperties[indexI].passengerType == 2) {
      passtype = "Child";
    }
    //updating the meal fee of respective custimer
    for (let v = 0; v < this.priceCardDetails.length; v++) {
      let mealFeeCalcu = 0;
      if (this.priceCardDetails[v].passengerType == passtype) {
        mealFeeCalcu = Number(this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].mealFee);
        mealFeeCalcu = Number(this.priceCardDetails[v].mealFee.slice(3)) + mealFeeCalcu;
        this.priceCardDetails[v].mealFee = this.currency + mealFeeCalcu.toFixed(2);
      }
    }
    //updating the pricees of price card
    for (let r = 0; r < this.priceCardDetails.length; r++) {

      let baseprice = Number(this.priceCardDetails[r].agencyBasePrice.substring(3));
      let taxprice = Number(this.priceCardDetails[r].agencyTaxes.substring(3));
      let serviceprice = Number(this.priceCardDetails[r].agencyServiceFee.substring(3));
      let disprice = Number(this.priceCardDetails[r].agencyDiscount.substring(3));
      let anciprice = Number(this.priceCardDetails[r].seatFee.substring(3));
      let ancimealprice = Number(this.priceCardDetails[r].mealFee.substring(3));
      let ancipricebag = Number(this.priceCardDetails[r].baggageFee.substring(3));
      let newpricetotal = (baseprice + taxprice + serviceprice + anciprice + ancipricebag + ancimealprice) - disprice;
      this.priceCardDetails[r].agencyTotalPrice = this.currency + newpricetotal.toFixed(2);
    }
    //updating the main total
    let basepriceTtl = 0;
    let taxpriceTtl = 0;
    let servicepriceTtl = 0;
    let dispriceTtl = 0;
    let ancipriceTtl = 0;
    let ancipricebagTtl = 0;
    let ancipricemealTtl = 0;
    let newpricetotalTtl = 0;

    for (let o = 0; o < this.priceCardDetails.length; o++) {

      basepriceTtl += Number(this.priceCardDetails[o].agencyBasePrice.substring(3));
      taxpriceTtl += Number(this.priceCardDetails[o].agencyTaxes.substring(3));
      servicepriceTtl += Number(this.priceCardDetails[o].agencyServiceFee.substring(3));
      dispriceTtl += Number(this.priceCardDetails[o].agencyDiscount.substring(3));
      ancipriceTtl += Number(this.priceCardDetails[o].seatFee.substring(3));
      ancipricemealTtl += Number(this.priceCardDetails[o].mealFee.substring(3));
      ancipricebagTtl += Number(this.priceCardDetails[o].baggageFee.substring(3));

    }
    newpricetotalTtl = (basepriceTtl + taxpriceTtl + servicepriceTtl + ancipriceTtl + ancipricebagTtl + ancipricemealTtl) - dispriceTtl;

    this.totalANCIConv = this.currency + (ancipriceTtl + ancipricemealTtl + ancipricebagTtl).toFixed(2);
    this.totalPriceConv = this.currency + newpricetotalTtl.toFixed(2);

  }
  baggageopen(i, z) {


    if (this.bookingInfo.bookingPassengerInfoProperties[i].sectorInformationProperties[z].fzBaggageList.length > 0) {
      document.getElementById(`baggagepopup${i}${z}`).classList.remove("numofseatmodel");
    }
    else {
      this.mealerror = false;
      this.baggageerror = true;
      document.getElementById("errormessage").style.visibility = "visible";
      setTimeout(() => {
        document.getElementById("errormessage").style.visibility = "hidden";

      }, 2000);
    }


  }
  baggageclose(i, z) {

    document.getElementById(`baggagepopup${i}${z}`).classList.add("numofseatmodel");

  }

  mealerror: boolean = false;
  baggageerror: boolean = false;
  fzBaggageClick(indexI, indexF, model) {

    this.fzBaggageArray = this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].fzBaggageList;


    //if (this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo.length == 1) {
      let tempArray = [];
      if (Number(this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageCheckIn.split("kg")[0]) == 0) {
        for (let a = 0; a < this.fzBaggageArray[0].length; a++) {

          if ((Number(this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageCheckIn.split("kg")[0])
            + Number(this.fzBaggageArray[0][a].description.split("kg")[0])) <= 40 && this.fzBaggageArray[0][a].description.includes("Upgrade") &&
            this.fzBaggageArray[0].offerCode != "BUPZ") {
            tempArray.push(this.fzBaggageArray[0][a]);
          }
          
        }
        
      } else if (Number(this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageCheckIn.split("kg")[0]) > 0) {
        for (let a = 0; a < this.fzBaggageArray[0].length; a++) {

          if ((Number(this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageCheckIn.split("kg")[0]) == 30)) {

            if ((Number(this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageCheckIn.split("kg")[0])
              + Number(this.fzBaggageArray[0][a].description.split("kg")[0])) <= 40 && this.fzBaggageArray[0][a].offerCode == "BUPZ") {
              tempArray.push(this.fzBaggageArray[0][a]);
            }

          } else if(
            Number(this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageCheckIn.split("kg")[0])
            + Number(this.fzBaggageArray[0][a].description.split("kg")[0]) <= 40
            && this.fzBaggageArray[0][a].description.includes("Upgrade")
            &&
            this.fzBaggageArray[0][a].offerCode != "BUPZ"){
            tempArray.push(this.fzBaggageArray[0][a]);
          }
        
        }
      }
    //}
   
    this.fzBaggageArray = tempArray;
    //for (let o = 0; o < this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].fzBaggageList.length; o++) {
      

      

    //}





    

    if (this.fzBaggageArray != null) {
      if (this.fzBaggageArray.length > 0) {
        this.baggageopen(indexI, indexF);
      }
      else {
        this.mealerror = false;
        this.baggageerror = true;
        document.getElementById("errormessage").style.visibility = "visible";
        setTimeout(() => {
          document.getElementById("errormessage").style.visibility = "hidden";

        }, 3000);
      }
    }
    else {
      this.mealerror = false;
      this.baggageerror = true;
      document.getElementById("errormessage").style.visibility = "visible";
      setTimeout(() => {
        document.getElementById("errormessage").style.visibility = "hidden";

      }, 3000);
    }

    //this.fzBaggageArray = this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggaesBysector;

    ///console.log(this.fzBaggageArray);
  }


  bagPersonIndex: number = 0;
  baglSectorIndex: number = 0;
  bagListIndex: number = 0;
  //fzBaggageSelect(indexI, indexF, indexM, indexA) {

  //  try {
  //    if (indexI == this.bagPersonIndex && this.baglSectorIndex == indexF) {


  //      document.getElementById(`baggageselectid${this.bagPersonIndex}${this.baglSectorIndex}${this.bagListIndex}`).innerHTML = "Select";
  //      document.getElementById(`baggageselectbtn${this.bagPersonIndex}${this.baglSectorIndex}${this.bagListIndex}`).style.backgroundColor = "#39454B";
  //      document.getElementById(`baggageselectbtn${this.bagPersonIndex}${this.baglSectorIndex}${this.bagListIndex}`).style.borderColor = "#39454B";
  //    }
  //  }
  //  catch (e) {

  //  }
  //  try {
  //    document.getElementById(`baggageselectid${indexI}${indexF}${indexM}${indexA}`).innerHTML = "Selected";
  //    document.getElementById(`baggageselectbtn${indexI}${indexF}${indexM}${indexA}`).style.borderColor = "var(--first-color-second)";
  //    document.getElementById(`baggageselectbtn${indexI}${indexF}${indexM}${indexA}`).style.backgroundColor = "var(--first-color-second)";
  //  }
  //  catch (e) {

  //  }
  //  this.bagPersonIndex = indexI;
  //  this.baglSectorIndex = indexF;
  //  this.bagListIndex = indexM;
  //  let baggagefee = 0;
  //  let baggagecheck: string;
  //  let baggagename: string;
  //  let baggagecode: string;
  //  let baggagedescription: string;
  //  if (this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageFee) {
  //    let passtype = "";
  //    if (this.bookingInfo.bookingPassengerInfoProperties[indexI].passengerType == 1) {
  //      passtype = "Adult";
  //    }
  //    else if (this.bookingInfo.bookingPassengerInfoProperties[indexI].passengerType == 2) {
  //      passtype = "Child";
  //    }
  //    //updating the meal fee of respective custimer
  //    //for (let v = 0; v < this.priceCardDetails.length; v++) {
  //    //  let mealFeeCalcu = 0;
  //    //  if (this.priceCardDetails[v].passengerType == passtype) {
  //    //    mealFeeCalcu = Number(this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageFee);
  //    //    mealFeeCalcu = Number(this.priceCardDetails[v].baggageFee.slice(3)) - mealFeeCalcu;
  //    //    this.priceCardDetails[v].baggageFee = this.currency + mealFeeCalcu;
  //    //  }
  //    //}

  //    this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageCheckIn = this.fzBaggageArray[indexM][indexA].description;
  //    baggagecheck = this.fzBaggageArray[indexM][indexA].description;
  //    baggagename = this.fzBaggageArray[indexM][indexA].description;
  //    this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggagename = this.fzBaggageArray[indexM][indexA].description;

  //    this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageFee = this.fzBaggageArray[indexM][indexA].amount * this.bookingInfo.passengerFares[0].currencyRate;
  //    baggagefee = this.fzBaggageArray[indexM][indexA].amount * this.bookingInfo.passengerFares[0].currencyRate;
  //    this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageCode = this.fzBaggageArray[indexM][indexA].code;
  //    baggagecode = this.fzBaggageArray[indexM].code;
  //    this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageDescription = this.fzBaggageArray[indexM][indexA].description;
  //    baggagedescription = this.fzBaggageArray[indexM][indexA].description;
  //    //this.priceCardDBaggagUpdation(indexI, indexF)

  //  } else {
  //    this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageCheckIn = this.fzBaggageArray[indexM][indexA].description;
  //    baggagecheck = this.fzBaggageArray[indexM][indexA].description;
  //    baggagename = this.fzBaggageArray[indexM][indexA].description;
  //    this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggagename = this.fzBaggageArray[indexM][indexA].description;

  //    this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageFee = this.fzBaggageArray[indexM][indexA].amount * this.bookingInfo.passengerFares[0].currencyRate;
  //    baggagefee = this.fzBaggageArray[indexM][indexA].amount * this.bookingInfo.passengerFares[0].currencyRate;
  //    this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageCode = this.fzBaggageArray[indexM][indexA].code;
  //    baggagecode = this.fzBaggageArray[indexM][indexA].code;
  //    this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageDescription = this.fzBaggageArray[indexM][indexA].description;
  //    baggagedescription = this.fzBaggageArray[indexM][indexA].description;
  //   // this.priceCardDBaggagUpdation(indexI, indexF)
  //  }
  //  if (this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo.length == 1) {
  //    for (let f = 0; f < this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties.length; f++) {

  //      this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[f].baggageCheckIn = baggagecheck;
  //      this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[f].baggagename = baggagename;
  //      this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[f].baggageFee = baggagefee;
  //      this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[f].baggageCode = baggagecode;
  //      this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[f].baggageDescription = baggagedescription;

  //    }

  //  }
  //  else {
  //    if (this.bookingInfo.bookingPassengerInfoProperties[0].sectorInformationProperties[0].noOfStops > 0) {
  //      for (let c = 0; c < this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo.length; c++) {
  //        for (let f = 0; f < this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties.length; f++) {
  //          if (this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[c].fromCity.trim() == this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].fromAirport
  //            && this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[c].toCity.trim() == this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[f].toAirport) {
  //            this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[f].baggageCheckIn = this.fzBaggageArray[indexM].description;
  //            this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[f].baggagename = this.fzBaggageArray[indexM].description;
  //            this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[f].baggageFee = this.fzBaggageArray[indexM].amount * this.bookingInfo.passengerFares[0].currencyRate;
  //            this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[f].baggageCode = this.fzBaggageArray[indexM].offerCode;
  //            this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[f].baggageDescription = this.fzBaggageArray[indexM].description;
  //          }
  //        }
  //      }

  //    }
  //  }

  //}

  bagPersonIndexA: boolean = false;
  fzBaggageSelect(indexI, indexF, indexM) {

    try {
      if (indexI == this.bagPersonIndex && this.baglSectorIndex == indexF) {


        document.getElementById(`baggageselectid${this.bagPersonIndex}${this.baglSectorIndex}${this.bagListIndex}`).innerHTML = "Select";
        document.getElementById(`baggageselectbtn${this.bagPersonIndex}${this.baglSectorIndex}${this.bagListIndex}`).style.backgroundColor = "#39454B";
        document.getElementById(`baggageselectbtn${this.bagPersonIndex}${this.baglSectorIndex}${this.bagListIndex}`).style.borderColor = "#39454B";
      }
    }
    catch (e) {

    }
    try {
      document.getElementById(`baggageselectid${indexI}${indexF}${indexM}`).innerHTML = "Selected";
      document.getElementById(`baggageselectbtn${indexI}${indexF}${indexM}`).style.borderColor = "var(--first-color-second)";
      document.getElementById(`baggageselectbtn${indexI}${indexF}${indexM}`).style.backgroundColor = "var(--first-color-second)";
    }
    catch (e) {

    }

    let baggagefee = 0;
    let baggagecheck: string;
    let baggagename: string;
    let baggagecode: string;
    let baggagedescription: string;
    if (this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageFee) {
      let passtype = "";
      if (this.bookingInfo.bookingPassengerInfoProperties[indexI].passengerType == 1) {
        passtype = "Adult";
      }
      else if (this.bookingInfo.bookingPassengerInfoProperties[indexI].passengerType == 2) {
        passtype = "Child";
      }
      //updating the meal fee of respective custimer
      for (let v = 0; v < this.priceCardDetails.length; v++) {
        let mealFeeCalcu = 0;
        if (this.priceCardDetails[v].passengerType == passtype) {
          mealFeeCalcu = Number(this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageFee);
          mealFeeCalcu = Number(this.priceCardDetails[v].baggageFee.slice(3)) - mealFeeCalcu;
          this.priceCardDetails[v].baggageFee = this.currency + mealFeeCalcu;
        }
      }

      this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageCheckIn = this.fzBaggageArray[indexM].description;
      baggagecheck = this.fzBaggageArray[indexM].description;
      baggagename = this.fzBaggageArray[indexM].description;
      this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggagename = this.fzBaggageArray[indexM].description;

      this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageFee = this.fzBaggageArray[indexM].amount * this.bookingInfo.passengerFares[0].currencyRate;
      baggagefee = this.fzBaggageArray[indexM].amount * this.bookingInfo.passengerFares[0].currencyRate;
      this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageCode = this.fzBaggageArray[indexM].code;
      baggagecode = this.fzBaggageArray[indexM].code;
      this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageDescription = this.fzBaggageArray[indexM].description;
      baggagedescription = this.fzBaggageArray[indexM].description;
      this.priceCardDBaggagUpdation(indexI, indexF)

    } else {
      this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageCheckIn = this.fzBaggageArray[indexM].description;
      baggagecheck = this.fzBaggageArray[indexM].description;
      baggagename = this.fzBaggageArray[indexM].description;
      this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggagename = this.fzBaggageArray[indexM].description;

      this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageFee = this.fzBaggageArray[indexM].amount * this.bookingInfo.passengerFares[0].currencyRate;
      baggagefee = this.fzBaggageArray[indexM].amount * this.bookingInfo.passengerFares[0].currencyRate;
      this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageCode = this.fzBaggageArray[indexM].code;
      baggagecode = this.fzBaggageArray[indexM].code;
      this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageDescription = this.fzBaggageArray[indexM].description;
      baggagedescription = this.fzBaggageArray[indexM].description;
      this.priceCardDBaggagUpdation(indexI, indexF)
    }
    if (this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo.length == 1) {
      for (let f = 0; f < this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties.length; f++) {

        this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[f].baggageCheckIn = baggagecheck;
        this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[f].baggagename = baggagename;
        this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[f].baggageFee = baggagefee;
        this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[f].baggageCode = baggagecode;
        this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[f].baggageDescription = baggagedescription;

      }

    }
    else {
      if (this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties.length > 2 && this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo.length==2) {
        for (let c = 0; c < this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo.length; c++) {
          for (let f = 0; f < this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties.length; f++) {
            if (this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[c].fromCity.trim() == this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].fromAirport
              && this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[c].toCity.trim() == this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[f].toAirport) {
              this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[f].baggageCheckIn = this.fzBaggageArray[indexM].description;
              this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[f].baggagename = this.fzBaggageArray[indexM].description;
              this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[f].baggageFee = this.fzBaggageArray[indexM].amount * this.bookingInfo.passengerFares[0].currencyRate;
              this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[f].baggageCode = this.fzBaggageArray[indexM].offerCode;
              this.bookingInfo.bookingPassengerInfoProperties[indexI].sectorInformationProperties[f].baggageDescription = this.fzBaggageArray[indexM].description;
            }
          }
        }

      }
    }
    this.bagPersonIndex = indexI;
    this.baglSectorIndex = indexF;
    this.bagListIndex = indexM;
    //this.bagPersonIndexA = indexA;
  }


  priceCardDBaggagUpdation(indexI, indexF) {
    let passtype = "";
    if (this.bookingInfo.bookingPassengerInfoProperties[indexI].passengerType == 1) {
      passtype = "Adult";
    }
    else if (this.bookingInfo.bookingPassengerInfoProperties[indexI].passengerType == 2) {
      passtype = "Child";
    }
    let newancifee = 0;
    for (let e = 0; e < this.bookingInfo.bookingPassengerInfoProperties.length; e++) {
      if (this.bookingInfo.bookingPassengerInfoProperties[e].passengerType == this.bookingInfo.bookingPassengerInfoProperties[indexI].passengerType) {
        for (let d = 0; d < this.bookingInfo.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
          if (this.bookingInfo.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggagebtn == true) {
            newancifee += this.bookingInfo.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggageFee;
          }
        }
      }
    }
    //updating the meal fee of respective custimer
    for (let v = 0; v < this.priceCardDetails.length; v++) {
      let mealFeeCalcu = 0;
      if (this.priceCardDetails[v].passengerType == passtype) {
        //mealFeeCalcu = Number(this.bookingObj.bookingPassengerInfoProperties[indexI].sectorInformationProperties[indexF].baggageFee);
        //mealFeeCalcu = Number(this.priceCardDetails[v].baggageFee.slice(3)) + mealFeeCalcu;
        this.priceCardDetails[v].baggageFee = this.currency + newancifee.toFixed(2);
      }
    }
    //updating the pricees of price card
    for (let r = 0; r < this.priceCardDetails.length; r++) {

      let baseprice = Number(this.priceCardDetails[r].agencyBasePrice.substring(3));
      let taxprice = Number(this.priceCardDetails[r].agencyTaxes.substring(3));
      let serviceprice = Number(this.priceCardDetails[r].agencyServiceFee.substring(3));
      let disprice = Number(this.priceCardDetails[r].agencyDiscount.substring(3));
      let anciprice = Number(this.priceCardDetails[r].seatFee.substring(3));
      let ancimealprice = Number(this.priceCardDetails[r].mealFee.substring(3));
      let ancipricebag = Number(this.priceCardDetails[r].baggageFee.substring(3));
      let newpricetotal = (baseprice + taxprice + serviceprice + anciprice + ancipricebag + ancimealprice) - disprice;
      this.priceCardDetails[r].agencyTotalPrice = this.currency + newpricetotal.toFixed(2);
    }
    //updating the main total
    let basepriceTtl = 0;
    let taxpriceTtl = 0;
    let servicepriceTtl = 0;
    let dispriceTtl = 0;
    let ancipriceTtl = 0;
    let ancipricebagTtl = 0;
    let ancipricemealTtl = 0;
    let newpricetotalTtl = 0;

    for (let o = 0; o < this.priceCardDetails.length; o++) {

      basepriceTtl += Number(this.priceCardDetails[o].agencyBasePrice.substring(3));
      taxpriceTtl += Number(this.priceCardDetails[o].agencyTaxes.substring(3));
      servicepriceTtl += Number(this.priceCardDetails[o].agencyServiceFee.substring(3));
      dispriceTtl += Number(this.priceCardDetails[o].agencyDiscount.substring(3));
      ancipriceTtl += Number(this.priceCardDetails[o].seatFee.substring(3));
      ancipricemealTtl += Number(this.priceCardDetails[o].mealFee.substring(3));
      ancipricebagTtl += Number(this.priceCardDetails[o].baggageFee.substring(3));

    }
    newpricetotalTtl = (basepriceTtl + taxpriceTtl + servicepriceTtl + ancipriceTtl + ancipricebagTtl + ancipricemealTtl) - dispriceTtl;
    this.totalANCIConv = this.currency + (ancipriceTtl + ancipricemealTtl + ancipricebagTtl).toFixed(2);
    this.totalPriceConv = this.currency + newpricetotalTtl.toFixed(2);

  }

  mealopen(i, z, model) {


    if (this.bookingInfo.providerCode == "FZ") {
      this.FZMeals = true;


      this.fzMealArray = this.bookingInfo.bookingPassengerInfoProperties[i].sectorInformationProperties[z].fzMealList;
      if (this.fzMealArray != null) {
        if (this.fzMealArray.length > 0) {
          document.getElementById(`fZmeal${i}${z}`).classList.remove("mealModel");
        }
        else {
          this.mealerror = true;
          this.baggageerror = false;
          document.getElementById("errormessage").style.visibility = "visible";
          setTimeout(() => {
            document.getElementById("errormessage").style.visibility = "hidden";

          }, 3000);
        }
      }
      else {
        this.mealerror = true;
        this.baggageerror = false;
        document.getElementById("errormessage").style.visibility = "visible";
        setTimeout(() => {
          document.getElementById("errormessage").style.visibility = "hidden";

        }, 3000);
      }
    }



  }

  mealclose(i, z) {

    document.getElementById(`fZmeal${i}${z}`).classList.add("mealModel");

  }

  //SubmitAnxiToBooking() {

  //  for (let j = 0; j < this.bookingInfo.bookingPassengerInfoProperties.length; j++) {
  //    for (let k = 0; k < this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties.length; k++) {
  //      this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[k].fzBaggageList = [];
  //      this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[k].fzMealList = [];
  //      this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[k].mealListBysector = [];
  //      this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[k].baggaesBysector = [];
  //    }
  //  }

  //  this.bookingInfo.exchangebookingPassengerInfoProperties = this.bookingInfo.bookingPassengerInfoProperties;
  //  this.flightService.SubmitAnxiToBooking(this.bookingInfo).subscribe((data) => {
  //    //this.isLoadPanelVisible = false;
  //    if (data) {


  //    }
  //    else {

  //    }
  //  });

  //}


  SubmitAnxiToBooking() {

    for (let j = 0; j < this.bookingInfo.bookingPassengerInfoProperties.length; j++) {
      for (let k = 0; k < this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties.length; k++) {
        this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[k].fzBaggageList = [];
        this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[k].fzMealList = [];
        this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[k].mealListBysector = [];
        this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[k].baggaesBysector = [];
      }
    }
    this.modifyBooking = true;
    this.bookingInfo.exchangebookingPassengerInfoProperties = this.bookingInfo.bookingPassengerInfoProperties;
    this.flightService.SubmitAnxiToBooking(this.bookingInfo).subscribe((data) => {
      this.modifyBooking = false;
      if (data) {

        this.OrigionalData = data;
        console.log(this.OrigionalData);
        //let modifyyyyy = JSON.parse(JSON.stringify(data.ModifyCarry));
        this.ModifyData = JSON.parse(JSON.stringify(JSON.parse(data.modifyCarry)));
        this.openModalOnInit();




        //var bookingid = data.bookingID;
        //localStorage.setItem("bookingID", String(bookingid));
        //this.router.navigateByUrl('/ticket-issuance');

      }
      else {

      }
    });

  }


  //SubmitAnxiToBooking() {

  //  for (let j = 0; j < this.bookingInfo.bookingPassengerInfoProperties.length; j++) {
  //    for (let k = 0; k < this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties.length; k++) {
  //      this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[k].fzBaggageList = [];
  //      this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[k].fzMealList = [];
  //      this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[k].mealListBysector = [];
  //      this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[k].baggaesBysector = [];
  //    }
  //  }

  //  this.bookingInfo.exchangebookingPassengerInfoProperties = this.bookingInfo.bookingPassengerInfoProperties;
  //  this.flightService.SubmitAnxiToBooking(this.bookingInfo).subscribe((data) => {
  //    if (data) {

  //      //var bookingdate = data.bookingDate;
  //      //let bDateLong: Date = new Date(bookingdate);
  //      //let datePipeArr: DatePipe = new DatePipe('en-UK');
  //      //let bookingDate = (datePipeArr.transform(bDateLong, 'MMM d, yyyy'));
  //      //this.sendBookingMail(bookingid, bookingDate);
  //      var bookingid = data.bookingID;
  //      localStorage.setItem("bookingID", String(bookingid));
  //      this.router.navigateByUrl('/ticket-issuance');

  //    }
  //    else {

  //    }
  //  });

  //}

  AddAnxillariesINTOBooking() {
    this.ngOnInit();
    this.modifyBooking = true;
    this.flightService.FZAddAnxillariesToBooking(this.bookingInfo).subscribe((data) => {

      //this.isLoadPanelVisible = false;
      if (data) {
        this.modifyBooking = false;
        this.bookingInfo.transactionIdentifierJ = data.transactionIdentifier;
        this.bookingInfo.galileoBookingProp.supplier = String(data.retrievePNRResponse);
        this.bookingInfo.currencyCriteriaThatApplied = data.currencyCriteriaThatApplied;
        this.currencyRate = data.byDefaultCurrencyRate;
        this.bookingInfo.bookingPassengerInfoProperties[0].tripType = JSON.stringify(data.flyDubaiAnxiResponse);
        this.flyDubaiAnxillaryProcessing(data);
        
      }
      else {
        this.modifyBooking = false;
      }
    });
  }
  fzAnxii: boolean;
  FZMeals: boolean = false;
  flyDubaiAnxillaryProcessing(data: FlyDubaiAnxiHandling) {
    let mealsinglesidelist = [];
    let mealreturnsidelist = [];
    let bagsinglesidelist = [];
    let bagreturnsidelist = [];

    let PnrResp = JSON.parse(data.retrievePNRResponse);
    
    this.fzAnxii = true;
    this.FZMeals = true;

    for (let j = 0; j < this.bookingInfo.bookingPassengerInfoProperties.length; j++) {
      for (let k = 0; k < this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties.length; k++) {
        this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[k].meal = null;
        this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[k].mealFee = 0;
        this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[k].baggageCode = null;
        this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[k].baggageDescription = null;
        this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[k].baggageFee = 0;
      }
        
      }
    
    for (let k = 0; k < data.flyDubaiAnxiResponse.length; k++) {
    for (let o = 0; o < data.flyDubaiAnxiResponse[k].ancillaryQuotes.flights.length; o++) {
      for (let d = 0; d < data.flyDubaiAnxiResponse[k].ancillaryQuotes.flights[o].legs.length; d++) {
        if (PnrResp.Airlines[0].LogicalFlight[0].LogicalFlightID == data.flyDubaiAnxiResponse[k].ancillaryQuotes.flights[o].legs[d].lfID) {
          
          mealsinglesidelist.push(data.flyDubaiAnxiResponse[k].ancillaryQuotes.flights[o].legs[d].serviceQuotes);
        }
        if (PnrResp.Airlines[0].LogicalFlight[1]) {
          if (PnrResp.Airlines[0].LogicalFlight[1].LogicalFlightID == data.flyDubaiAnxiResponse[k].ancillaryQuotes.flights[o].legs[d].lfID) {

            mealreturnsidelist.push(data.flyDubaiAnxiResponse[k].ancillaryQuotes.flights[o].legs[d].serviceQuotes);
          }
        }
      }
      }
    }
    for (let k = 0; k < data.flyDubaiAnxiResponse.length; k++) {
      for (let o = 0; o < data.flyDubaiAnxiResponse[k].ancillaryQuotes.flights.length; o++) {
        // for (let d = 0; d < data.flyDubaiAnxiResponse.ancillaryQuotes.flights[o]; d++) {
        if (PnrResp.Airlines[0].LogicalFlight[0].LogicalFlightID == data.flyDubaiAnxiResponse[k].ancillaryQuotes.flights[o].segments.lfID) {
          bagsinglesidelist.push(data.flyDubaiAnxiResponse[k].ancillaryQuotes.flights[o].segments.serviceQuotes);
        }
        if (PnrResp.Airlines[0].LogicalFlight[1]) {
          if (PnrResp.Airlines[0].LogicalFlight[1].LogicalFlightID == data.flyDubaiAnxiResponse[k].ancillaryQuotes.flights[o].segments.lfID) {
            bagreturnsidelist.push(data.flyDubaiAnxiResponse[k].ancillaryQuotes.flights[o].segments.serviceQuotes);
          }
        }
        //}

      }
    }


    for (let j = 0; j < this.bookingInfo.bookingPassengerInfoProperties.length; j++) {

      if (this.bookingInfo.bookingPassengerInfoProperties[j].passengerType != 3) {
        for (let z = 0; z < this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties.length; z++) {
          if (this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo.length == 1) {
            let baggageArray = [];
           
            for (let h = 0; h < bagsinglesidelist.length; h++) {
              baggageArray.push(bagsinglesidelist[h]);
            }
  



            //this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealListBysector = mealsinglesidelist;
            this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzMealList = mealsinglesidelist;
           
            //this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggaesBysector = baggageArray;
            this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzBaggageList = baggageArray;
            this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;

            if (z == 0) {
              this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
            }
            else {
              this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = false;
            }


          }
          else if (this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo.length== 2) {


            /* return single flight*/
            if (this.bookingInfo.bookingPassengerInfoProperties[0].sectorInformationProperties[0].noOfStops == 0) {

              if (this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[0].fromCity.trim() == this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport) {
                //this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealListBysector = mealsinglesidelist;
                this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzMealList = mealsinglesidelist;

                this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
                let baggageArray = [];
                
                  for (let h = 0; h < bagsinglesidelist.length; h++) {
                      baggageArray.push(bagsinglesidelist[h]);
                  }


               // this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggaesBysector = baggageArray;
                this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzBaggageList = baggageArray;
              }
              else if (this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[0].toCity.trim() == this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport) {
               // this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealListBysector = mealreturnsidelist;
                this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzMealList = mealreturnsidelist;

                let baggageArray = [];
                
                  for (let h = 0; h < bagsinglesidelist.length; h++) {
                      baggageArray.push(bagsinglesidelist[h]);  
                  }
                
               // this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggaesBysector = baggageArray;
                this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzBaggageList = baggageArray;

              }

              if (this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[1].fromCity.trim() == this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport) {
                //this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealListBysector = mealreturnsidelist;
                this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzMealList = mealreturnsidelist;

                this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
                let baggageArray = [];
                
                for (let h = 0; h < bagreturnsidelist.length; h++) {
                  baggageArray.push(bagreturnsidelist[h]);
                }
                 
                //this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggaesBysector = baggageArray;
                this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzBaggageList = baggageArray;
              } else if (this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[1].toCity.trim() == this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport) {
                this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealListBysector = mealreturnsidelist;
                this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzMealList = mealreturnsidelist;

                let baggageArray = [];
                
                  for (let h = 0; h < bagreturnsidelist.length; h++) {
                      baggageArray.push(bagreturnsidelist[h]);    
                  }
               
               // this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggaesBysector = baggageArray;
                this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzBaggageList = baggageArray;

              }
            }
            /*return connecting */
            else if (this.bookingInfo.bookingPassengerInfoProperties[0].sectorInformationProperties[0].noOfStops > 0) {
              if (this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[0].fromCity.trim() == this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport
                && this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[0].toCity.trim() != this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport) {
               // this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealListBysector = mealsinglesidelist;
                this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzMealList = mealsinglesidelist;
                let baggageArray = [];
                
                  for (let h = 0; h < bagsinglesidelist.length; h++) {
                      baggageArray.push(bagsinglesidelist[h]);      
                  }
                
                //this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggaesBysector = baggageArray;
                this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzBaggageList = baggageArray;
                this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
              }
              else if (this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[0].fromCity.trim() != this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport
                && this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[0].toCity.trim() == this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport) {
               // this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealListBysector = mealsinglesidelist;
                this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzMealList = mealsinglesidelist;
                let baggageArray = [];
                
                  for (let h = 0; h < bagsinglesidelist.length; h++) {
                      baggageArray.push(bagsinglesidelist[h]);
                  }
                 
              //  this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggaesBysector = baggageArray;
                this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzBaggageList = baggageArray;

              }
              else if (this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[1].fromCity.trim() == this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport
                && this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[1].toCity.trim() != this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport) {
              //  this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealListBysector = mealreturnsidelist;
                this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzMealList = mealreturnsidelist;
                let baggageArray = [];
                
                  for (let h = 0; h < bagreturnsidelist.length; h++) {
                      baggageArray.push(bagreturnsidelist[h]);  
                  }
              
              //  this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggaesBysector = baggageArray;
                this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzBaggageList = baggageArray;
                this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
              }
              else if (this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[1].fromCity.trim() != this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport
                && this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[1].toCity.trim() == this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport) {
              //  this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealListBysector = mealreturnsidelist;
                this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzMealList = mealreturnsidelist;
                let baggageArray = [];
                
                  for (let h = 0; h < bagreturnsidelist.length; h++) {
                      baggageArray.push(bagreturnsidelist[h]);
                  }
                
              //  this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggaesBysector = baggageArray;
                this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzBaggageList = baggageArray;

              }
            }



          }
        }
      }
    }


    console.log(this.bookingInfo.bookingPassengerInfoProperties);
    var hid = document.querySelector('.hhh') as HTMLDivElement;
    hid.classList.remove("hid-anxi");


  }

  RemoveAnxillariesFromBooking() {
    this.ngOnInit();
    this.fzAnxii = true;
    this.FZMeals = true;
    for (let j = 0; j < this.bookingInfo.bookingPassengerInfoProperties.length; j++) {

      if (this.bookingInfo.bookingPassengerInfoProperties[j].passengerType != 3) {
        for (let z = 0; z < this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties.length; z++) {
          if (this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo.length == 1) {
          
            this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;

            if (z == 0) {
              this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
            }
            else {
              this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = false;
            }


          }
          else if (this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo.length == 2) {


            /* return single flight*/
            if (this.bookingInfo.bookingPassengerInfoProperties[0].sectorInformationProperties[0].noOfStops == 0) {

              if (this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[0].fromCity.trim() == this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport) {

                this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;

              }
              else if (this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[0].toCity.trim() == this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport) {
               
              }

              if (this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[1].fromCity.trim() == this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport) {

               
                this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
               

              }
            }
            /*return connecting */
            else if (this.bookingInfo.bookingPassengerInfoProperties[0].sectorInformationProperties[0].noOfStops > 0) {
              if (this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[0].fromCity.trim() == this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport
                && this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[0].toCity.trim() != this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport) {
                // this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealListBysector = mealsinglesidelist;
               
                this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
              }
              else if (this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[0].fromCity.trim() != this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport
                && this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[0].toCity.trim() == this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport) {
              
                }

              

              }
              else if (this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[1].fromCity.trim() == this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport
                && this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[1].toCity.trim() != this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport) {
               
                this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
              }
              else if (this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[1].fromCity.trim() != this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport
                && this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo[1].toCity.trim() == this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport) {
               

              }
            }



          }
        }
      }
    

    console.log(this.bookingInfo.bookingPassengerInfoProperties);
    var hid = document.querySelector('.rm-anxi') as HTMLDivElement;
    hid.classList.remove("rrrm-anxi");


  }

  RemoveAnxiFromPNR() {
    let checkbagmeal = false;
    for (let i = 0; i < this.bookingInfo.bookingPassengerInfoProperties.length; i++) {
      for (let s = 0; s < this.bookingInfo.bookingPassengerInfoProperties[i].sectorInformationProperties.length;s++) {
        if (this.bookingInfo.bookingPassengerInfoProperties[i].sectorInformationProperties[s].mealRemReq) {
          checkbagmeal = true;
          break;
        }
        if (this.bookingInfo.bookingPassengerInfoProperties[i].sectorInformationProperties[s].bagRemReq) {
          checkbagmeal = true;
          break;
        }
      }
    }
    if (!checkbagmeal) {
      document.getElementById("removeanxiid").innerHTML = "Remove One of them is compulsory.";
      return;
    }
    else{
      document.getElementById("removeanxiid").innerHTML = "";
    }
    this.modifyBooking = true;
    this.flightService.FZRemoveAnxiFromPnr(this.bookingInfo).subscribe((data) => {
      this.modifyBooking = false;
      //this.isLoadPanelVisible = false;
      if (data) {

        this.OrigionalData = data;
        this.ModifyData = JSON.parse(JSON.stringify(JSON.parse(data.modifyCarry)));
        this.openModalOnInit();


        //var bookingid = data.bookingID;
        //localStorage.setItem("bookingID", String(bookingid));
        //this.router.navigateByUrl('/ticket-issuance');
        //console.log(data);
        //console.log(this.bookingInfo);

      }
      else {

      }
    });



  }


  //RemoveAnxiFromPNR() {

  //  this.flightService.FZRemoveAnxiFromPnr(this.bookingInfo).subscribe((data) => {
  //    //this.isLoadPanelVisible = false;
  //    if (data) {


  //      var bookingid = data.bookingID;
  //      localStorage.setItem("bookingID", String(bookingid));
  //      this.router.navigateByUrl('/ticket-issuance');

  //    }
  //    else {

  //    }
  //  });

  //}

  mealAirArabiaList = new MealAirArabiaProperties();
  GetSeatsForBooking() {
    this.ngOnInit();
    this.fzAnxii = true;
    this.modifyBooking = true;
    this.userService.getSeatForFZModification(this.bookingInfo).subscribe((fzanci) => {
      this.modifyBooking = false;
      this.currencyRate = fzanci.byDefaultCurrencyRate;
      this.bookingInfo.currencyCriteriaThatApplied = fzanci.currencyCriteriaThatApplied;
      for (let j = 0; j < this.bookingInfo.bookingPassengerInfoProperties.length; j++) {

        if (this.bookingInfo.bookingPassengerInfoProperties[j].passengerType != 3) {
          for (let z = 0; z < this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties.length; z++) {
            if (fzanci != null) {
              if (fzanci.seatbysector != null) {

                if (fzanci.seatbysector != null) {
                  this.mealAirArabiaList.seatbysector = fzanci.seatbysector;
                  for (let y = 0; y < this.mealAirArabiaList.seatbysector.length; y++) {
                    if (this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.mealAirArabiaList.seatbysector[y].fromCity
                      && this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.mealAirArabiaList.seatbysector[y].toCity) {

                      this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListBysector = JSON.parse(JSON.stringify(this.mealAirArabiaList.seatbysector[y].rows));
                      this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fzSeatList = fzanci.error;/////here
                      break;
                    }
                  }
                }


              }
            }


          }
        }

      }

      if (fzanci) {
        //seat-anxi
        var hid = document.querySelector('.seat-anxi') as HTMLDivElement;
        hid.classList.remove("hid-seats");
      }




    });


  }

  anciService: boolean;
  passngerIndex: number = 0;
  sectorIndex: number = 0;
  seatListIndex: number = 0;
  seatIndex: number = 0;

  seatselectedsector(i, z, k, q) {

    if (this.bookingInfo.brandAirArabia == false) {
      this.anciService = true;
    }
    this.bookingInfo.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatNumber
      = this.bookingInfo.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatListBysector[k].seats[q].seatCode;
    this.bookingInfo.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatFee
      = Number(this.bookingInfo.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatListBysector[k].seats[q].seatCharge);
    try {
      if (i == this.passngerIndex && z == this.sectorIndex) {
        document.getElementById(`link3button${this.passngerIndex}${this.sectorIndex}${this.seatListIndex}${this.seatIndex}`).classList.remove('classofseats');
        for (let y = 0; y < this.bookingInfo.bookingPassengerInfoProperties.length; y++) {
          if (this.bookingInfo.bookingPassengerInfoProperties[y].passengerType != 3) {
            if (i != y) {
              this.bookingInfo.bookingPassengerInfoProperties[y].sectorInformationProperties[this.sectorIndex].seatListBysector[this.seatListIndex].seats[this.seatIndex].seatStatus = "VAC";

            }
          }


        }
      }


    }
    catch (e) {
      ////Console.log(e);
    }
    for (let y = 0; y < this.bookingInfo.bookingPassengerInfoProperties.length; y++) {
      if (this.bookingInfo.bookingPassengerInfoProperties[y].passengerType != 3) {

        if (i != y) {
          this.bookingInfo.bookingPassengerInfoProperties[y].sectorInformationProperties[z].seatListBysector[k].seats[q].seatStatus = "RSP";

        }
      }
    }
    document.getElementById(`link3button${i}${z}${k}${q}`).classList.add('classofseats');
    this.passngerIndex = i;
    //console.log(this.passngerIndex, this.seatIndex, this.seatListIndex, this.seatselected);
    this.sectorIndex = z;
    this.seatListIndex = k;
    this.seatIndex = q;
    //console.log(this.bookingInfo);
    /*    for oneway*/
    let pstype = "";
    if (this.bookingInfo.bookingPassengerInfoProperties[i].passengerType == 1) {
      pstype = "Adult";
    }
    else if (this.bookingInfo.bookingPassengerInfoProperties[i].passengerType == 2) {
      pstype = "Child";
    }
    if (this.bookingInfo.galileoBookingProp.flightProp.flightLocationInfo.length >= 1) {
      /*   check stops*/
      if (this.bookingInfo.bookingPassengerInfoProperties[i].sectorInformationProperties.length == 1) {
        let newancifee = 0;
        for (let e = 0; e < this.bookingInfo.bookingPassengerInfoProperties.length; e++) {
          if (this.bookingInfo.bookingPassengerInfoProperties[e].passengerType == this.bookingInfo.bookingPassengerInfoProperties[i].passengerType) {
            for (let d = 0; d < this.bookingInfo.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
              newancifee += Number(this.bookingInfo.bookingPassengerInfoProperties[e].sectorInformationProperties[d].seatFee);
            }
          }
        }
        for (let u = 0; u < this.priceCardDetails.length; u++) {
          if (this.priceCardDetails[u].passengerType == pstype) {
            this.priceCardDetails[u].seatFee = this.currency + (newancifee * this.priceCardDetails[u].currencyRate).toFixed(2);
          }

        }

      }
      else if (this.bookingInfo.bookingPassengerInfoProperties[i].sectorInformationProperties.length > 1) {
        let newancifee = 0;
        for (let e = 0; e < this.bookingInfo.bookingPassengerInfoProperties.length; e++) {
          if (this.bookingInfo.bookingPassengerInfoProperties[e].passengerType == this.bookingInfo.bookingPassengerInfoProperties[i].passengerType) {
            for (let d = 0; d < this.bookingInfo.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
              newancifee += Number(this.bookingInfo.bookingPassengerInfoProperties[e].sectorInformationProperties[d].seatFee);
            }
          }
        }
        for (let u = 0; u < this.priceCardDetails.length; u++) {
          if (this.priceCardDetails[u].passengerType == pstype) {
            this.priceCardDetails[u].seatFee = this.currency + (newancifee * this.priceCardDetails[u].currencyRate).toFixed(2);
          }

        }
      }
    }

    for (let r = 0; r < this.priceCardDetails.length; r++) {

      let baseprice = Number(this.priceCardDetails[r].agencyBasePrice.substring(3));
      let taxprice = Number(this.priceCardDetails[r].agencyTaxes.substring(3));
      let serviceprice = Number(this.priceCardDetails[r].agencyServiceFee.substring(3));
      let disprice = Number(this.priceCardDetails[r].agencyDiscount.substring(3));
      let anciprice = Number(this.priceCardDetails[r].seatFee.substring(3));
      let ancimealprice = Number(this.priceCardDetails[r].mealFee.substring(3));
      let ancipricebag = Number(this.priceCardDetails[r].baggageFee.substring(3));
      let newpricetotal = (baseprice + taxprice + serviceprice + anciprice + ancipricebag + ancimealprice) - disprice;
      this.priceCardDetails[r].agencyTotalPrice = this.currency + newpricetotal.toFixed(2);

    }

    /*   for return*/



    let basepriceTtl = 0;
    let taxpriceTtl = 0;
    let servicepriceTtl = 0;
    let dispriceTtl = 0;
    let ancipriceTtl = 0;
    let ancipricebagTtl = 0;
    let ancipricemealTtl = 0;
    let newpricetotalTtl = 0;
    for (let o = 0; o < this.priceCardDetails.length; o++) {
      //basepriceTtl += Number(this.priceCardDetails[o].indivisualBasePrice.substring(3));
      //taxpriceTtl += Number(this.priceCardDetails[o].indivisualTaxes.substring(3));
      //servicepriceTtl += Number(this.priceCardDetails[o].serviceFee.substring(3));
      //dispriceTtl += Number(this.priceCardDetails[o].discount.substring(3));
      //ancipriceTtl += Number(this.priceCardDetails[o].seatFee.substring(3));
      //ancipricemealTtl += Number(this.priceCardDetails[o].mealFee.substring(3));
      //ancipricebagTtl += Number(this.priceCardDetails[o].baggageFee.substring(3));

      basepriceTtl += Number(this.priceCardDetails[o].agencyBasePrice.substring(3));
      taxpriceTtl += Number(this.priceCardDetails[o].agencyTaxes.substring(3));
      servicepriceTtl += Number(this.priceCardDetails[o].agencyServiceFee.substring(3));
      dispriceTtl += Number(this.priceCardDetails[o].agencyDiscount.substring(3));
      ancipriceTtl += Number(this.priceCardDetails[o].seatFee.substring(3));
      ancipricemealTtl += Number(this.priceCardDetails[o].mealFee.substring(3));
      ancipricebagTtl += Number(this.priceCardDetails[o].baggageFee.substring(3));

    }
    newpricetotalTtl = (basepriceTtl + taxpriceTtl + servicepriceTtl + ancipriceTtl + ancipricebagTtl + ancipricemealTtl) - dispriceTtl;
    this.totalANCIConv = this.currency + (ancipriceTtl + ancipricemealTtl + ancipricebagTtl).toFixed(2);
    this.totalPriceConv = this.currency + newpricetotalTtl.toFixed(2);
    this.seatcheck = true;
  }



  //seatselectedsector(i, z, k, q) {
  //  if (this.bookingInfo.brandAirArabia == false) {
  //    this.anciService = true;
  //  }
  //  this.bookingInfo.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatNumber
  //    = this.bookingInfo.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatListBysector[k].seats[q].seatCode;
  //  this.bookingInfo.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatFee
  //    = Number(this.bookingInfo.bookingPassengerInfoProperties[i].sectorInformationProperties[z].seatListBysector[k].seats[q].seatCharge);
  //  try {
  //    if (i == this.passngerIndex && z == this.sectorIndex) {
  //      document.getElementById(`link3button${this.passngerIndex}${this.sectorIndex}${this.seatListIndex}${this.seatIndex}`).classList.remove('classofseats');
  //      for (let y = 0; y < this.bookingInfo.bookingPassengerInfoProperties.length; y++) {
  //        if (this.bookingInfo.bookingPassengerInfoProperties[y].passengerType != 3) {
  //          if (i != y) {
  //            this.bookingInfo.bookingPassengerInfoProperties[y].sectorInformationProperties[this.sectorIndex].seatListBysector[this.seatListIndex].seats[this.seatIndex].seatStatus = "VAC";

  //          }
  //        }


  //      }
  //    }


  //  }
  //  catch (e) {
  //    console.log(e);
  //  }
  //  for (let y = 0; y < this.bookingInfo.bookingPassengerInfoProperties.length; y++) {
  //    if (this.bookingInfo.bookingPassengerInfoProperties[y].passengerType != 3) {

  //      if (i != y) {
  //        this.bookingInfo.bookingPassengerInfoProperties[y].sectorInformationProperties[z].seatListBysector[k].seats[q].seatStatus = "RSP";

  //      }
  //    }
  //  }
  //  document.getElementById(`link3button${i}${z}${k}${q}`).classList.add('classofseats');
  //  this.passngerIndex = i;
  //  //console.log(this.passngerIndex, this.seatIndex, this.seatListIndex, this.seatselected);
  //  this.sectorIndex = z;
  //  this.seatListIndex = k;
  //  this.seatIndex = q;
  //  //console.log(this.bookingInfo);
  //  /*    for oneway*/
  //  let pstype = "";
  //  if (this.bookingInfo.bookingPassengerInfoProperties[i].passengerType == 1) {
  //    pstype = "Adult";
  //  }
  //  else if (this.bookingInfo.bookingPassengerInfoProperties[i].passengerType == 2) {
  //    pstype = "Child";
  //  }
  //  //if (this.bookingBaseData.flightProp.flightLocationInfo.length >= 1) {
  //  //  /*   check stops*/
  //  //  if (this.bookingBaseData.airSegment.length == 1) {
  //  //    let newancifee = 0;
  //  //    for (let e = 0; e < this.bookingInfo.bookingPassengerInfoProperties.length; e++) {
  //  //      if (this.bookingInfo.bookingPassengerInfoProperties[e].passengerType == this.bookingInfo.bookingPassengerInfoProperties[i].passengerType) {
  //  //        for (let d = 0; d < this.bookingInfo.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
  //  //          newancifee += Number(this.bookingInfo.bookingPassengerInfoProperties[e].sectorInformationProperties[d].seatFee);
  //  //        }
  //  //      }
  //  //    }
  //  //    for (let u = 0; u < this.priceCardDetails.length; u++) {
  //  //      if (this.priceCardDetails[u].passengerType == pstype) {
  //  //        this.priceCardDetails[u].seatFee = this.currency + (newancifee * this.priceCardDetails[u].currencyRate).toFixed(2);
  //  //      }

  //  //    }

  //  //  }
  //  //  else if (this.bookingBaseData.airSegment.length > 1) {
  //  //    let newancifee = 0;
  //  //    for (let e = 0; e < this.bookingInfo.bookingPassengerInfoProperties.length; e++) {
  //  //      if (this.bookingInfo.bookingPassengerInfoProperties[e].passengerType == this.bookingInfo.bookingPassengerInfoProperties[i].passengerType) {
  //  //        for (let d = 0; d < this.bookingInfo.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
  //  //          newancifee += Number(this.bookingInfo.bookingPassengerInfoProperties[e].sectorInformationProperties[d].seatFee);
  //  //        }
  //  //      }
  //  //    }
  //  //    for (let u = 0; u < this.priceCardDetails.length; u++) {
  //  //      if (this.priceCardDetails[u].passengerType == pstype) {
  //  //        this.priceCardDetails[u].seatFee = this.currency + (newancifee * this.priceCardDetails[u].currencyRate).toFixed(2);
  //  //      }

  //  //    }
  //  //  }
  //  //}

  //  //for (let r = 0; r < this.priceCardDetails.length; r++) {
  
  //  //  let baseprice = Number(this.priceCardDetails[r].agencyBasePrice.substring(3));
  //  //  let taxprice = Number(this.priceCardDetails[r].agencyTaxes.substring(3));
  //  //  let serviceprice = Number(this.priceCardDetails[r].agencyServiceFee.substring(3));
  //  //  let disprice = Number(this.priceCardDetails[r].agencyDiscount.substring(3));
  //  //  let anciprice = Number(this.priceCardDetails[r].seatFee.substring(3));
  //  //  let ancimealprice = Number(this.priceCardDetails[r].mealFee.substring(3));
  //  //  let ancipricebag = Number(this.priceCardDetails[r].baggageFee.substring(3));
  //  //  let newpricetotal = (baseprice + taxprice + serviceprice + anciprice + ancipricebag + ancimealprice) - disprice;
  //  //  this.priceCardDetails[r].agencyTotalPrice = this.currency + newpricetotal.toFixed(2);

  //  //}

  //  ///*   for return*/



  //  //let basepriceTtl = 0;
  //  //let taxpriceTtl = 0;
  //  //let servicepriceTtl = 0;
  //  //let dispriceTtl = 0;
  //  //let ancipriceTtl = 0;
  //  //let ancipricebagTtl = 0;
  //  //let ancipricemealTtl = 0;
  //  //let newpricetotalTtl = 0;
  //  //for (let o = 0; o < this.priceCardDetails.length; o++) {
  //  //  //basepriceTtl += Number(this.priceCardDetails[o].indivisualBasePrice.substring(3));
  //  //  //taxpriceTtl += Number(this.priceCardDetails[o].indivisualTaxes.substring(3));
  //  //  //servicepriceTtl += Number(this.priceCardDetails[o].serviceFee.substring(3));
  //  //  //dispriceTtl += Number(this.priceCardDetails[o].discount.substring(3));
  //  //  //ancipriceTtl += Number(this.priceCardDetails[o].seatFee.substring(3));
  //  //  //ancipricemealTtl += Number(this.priceCardDetails[o].mealFee.substring(3));
  //  //  //ancipricebagTtl += Number(this.priceCardDetails[o].baggageFee.substring(3));

  //  //  basepriceTtl += Number(this.priceCardDetails[o].agencyBasePrice.substring(3));
  //  //  taxpriceTtl += Number(this.priceCardDetails[o].agencyTaxes.substring(3));
  //  //  servicepriceTtl += Number(this.priceCardDetails[o].agencyServiceFee.substring(3));
  //  //  dispriceTtl += Number(this.priceCardDetails[o].agencyDiscount.substring(3));
  //  //  ancipriceTtl += Number(this.priceCardDetails[o].seatFee.substring(3));
  //  //  ancipricemealTtl += Number(this.priceCardDetails[o].mealFee.substring(3));
  //  //  ancipricebagTtl += Number(this.priceCardDetails[o].baggageFee.substring(3));

  //  //}
  //  //newpricetotalTtl = (basepriceTtl + taxpriceTtl + servicepriceTtl + ancipriceTtl + ancipricebagTtl + ancipricemealTtl) - dispriceTtl;
  //  //this.totalANCIConv = this.currency + (ancipriceTtl + ancipricemealTtl + ancipricebagTtl).toFixed(2);
  //  //this.totalPriceConv = this.currency + newpricetotalTtl.toFixed(2);

  //}


  seatMapopen(i, z) {
    //this.modalService.open(model, {
    //  size: 'lg',
    //})
    document.getElementById(`newmodelofseat${i}${z}`).classList.remove("numofseatmodel");
    /*document.getElementById("newmodelofseat").classList.remove(numofseatmodel);*/

  }
  seatMapclose(i, z) {
    //this.modalService.open(model, {
    //  size: 'lg',
    //})
    document.getElementById(`newmodelofseat${i}${z}`).classList.add("numofseatmodel");
    /*document.getElementById("newmodelofseat").classList.remove(numofseatmodel);*/

  }
  submitSeatsForBookingMod() {
    if (!this.seatcheck) {
      document.getElementById("seataddid").innerHTML = "Please Select Seat!";
      return;
    }
    else {
      document.getElementById("seataddid").innerHTML = "";
    }
    this.modifyBooking = true;
    this.flightService.FZAddSeatToBooking(this.bookingInfo).subscribe((data) => {
      this.modifyBooking = false;
      //this.isLoadPanelVisible = false;
      if (data) {

        this.OrigionalData = data;
        this.ModifyData = JSON.parse(JSON.stringify(JSON.parse(data.modifyCarry)));
        this.openModalOnInit();

        //console.log(data);
        //console.log(this.bookingInfo);

      }
      else {

      }
    });
  }


  RemoveSeatsFromBooking() {
    this.ngOnInit();
    this.fzAnxii = true;
    this.FZMeals = true;

    console.log(this.bookingInfo.bookingPassengerInfoProperties);
    var hid = document.querySelector('.seat-rem-anxi') as HTMLDivElement;
    hid.classList.remove("hid-rem-seats");

  }


  submitRemoveSeatsMod() {
    let checkbagmeal = false;
    for (let i = 0; i < this.bookingInfo.bookingPassengerInfoProperties.length; i++) {
      for (let s = 0; s < this.bookingInfo.bookingPassengerInfoProperties[i].sectorInformationProperties.length; s++) {
        if (this.bookingInfo.bookingPassengerInfoProperties[i].sectorInformationProperties[s].seatRemReq) {
          checkbagmeal = true;
          break;
        }
        
      }
    }
    if (!checkbagmeal) {
      document.getElementById("removeseatid").innerHTML = "Remove One of them is compulsory.";
      return;
    }
    else {
      document.getElementById("removeseatid").innerHTML = "";
    }
    this.modifyBooking = true;
    this.flightService.FZRemoveSeatFromPnr(this.bookingInfo).subscribe((data) => {
      //this.isLoadPanelVisible = false;
      this.modifyBooking = false;
      if (data) {


        this.OrigionalData = data;
        this.ModifyData = JSON.parse(JSON.stringify(JSON.parse(data.modifyCarry)));
        this.openModalOnInit();

        // console.log(data);
        // console.log(this.bookingInfo);

      }
      else {

      }
    });


  }
  //submitRemoveSeatsMod() {

  //  this.flightService.FZRemoveSeatFromPnr(this.bookingInfo).subscribe((data) => {
  //    //this.isLoadPanelVisible = false;
  //    if (data) {
  //      var bookingid = data.bookingID;
  //      localStorage.setItem("bookingID", String(data.bookingID));
  //      this.router.navigateByUrl('/ticket-issuance');
  //      console.log(data);
  //      console.log(this.bookingInfo);

  //    }
  //    else {

  //    }
  //  });


  //}

  currency: string = "";
  currencyRate: number = 0;
  currencyRateJ: number = 0;
  totalTaxes: number = 0;
  totalPrice: number = 0;
  totalBasePriceConv: string = "";
  totalBasePrice: number = 0;
  totalTaxesConv: string = "";
  totalANCIConv: string = "";
  totalPriceConv: string = "";
  totalServiceFee: number = 0;
  totalDiscount: number = 0;
  totalServiceFeeConv: string = "";
  totalDiscountConv: string = "";
  priceCardDetails: PriceCardDetails[] = [];
  ProcessSegments() {

   

    let flightProp: FlightSearchProperties;

    //let airSegment = this.bookingBaseData.airSegment;
    //let airSegment = this.bookingInfo.bookingPassengerInfoProperties[0].sectorInformationProperties;

    //flightProp = this.bookingInfo.galileoBookingProp.flightProp;

    //for (let i = 0; i < airSegment.length; i++) {

    //  let airSeg = new AirSegmentsDetails();

    //  if (this.bookingInfo.providerCode != "FZ") {


    //    for (let j = 0; j < this.bookingInfo.bookingPassengerInfoProperties.length; j++) {
    //      if (this.bookingInfo.providerCode == "J9") {
    //        if (i >= 1)
    //          break;
    //      }
    //      if (i == 0)
    //        this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties = [];

    //      for (let l = 0; l < this.bookingInfo.bookingPassengerInfoProperties[j].sectorInformationProperties.length; l++) {
    //        let sectorObj = new SectorInformationProperties();
    //        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.push(sectorObj);
    //      }
    //    }

    //  }

    //  if (this.bookingBaseData.supplierCode == "G9" || this.bookingBaseData.supplierCode == "3L" || this.bookingBaseData.supplierCode == "9P") {
    //    let dptDate = airSegment[i].departureDate;



    //    let stopDepTime = airSegment[i].departureDate;
    //    let departPipe: DatePipe = new DatePipe('en-US');
    //    if (stopDepTime.length >= 16) {
     
    //      stopDepTime = stopDepTime.split('T')[0];
    //      airSeg.depatureDateTime = (departPipe.transform(stopDepTime, "EEE,MMM d, y")) + "," + airSegment[i].departureDate.slice(11, 16);
    //    }

    //    else
    //      airSeg.depatureDateTime = stopDepTime;

    //    let stopArrivTime = airSegment[i].arrivalDate;
    //    let arrivePipe: DatePipe = new DatePipe('en-US');

    //    if (stopArrivTime.length >= 16) {
         
    //      stopArrivTime = stopArrivTime.split('T')[0];
    //      airSeg.arrivalDateTime = (arrivePipe.transform(stopArrivTime, "EEE,MMM d, y")) + "," + airSegment[i].arrivalDate.slice(11, 16);
    //    }
    //    else
    //      airSeg.arrivalDateTime = stopArrivTime;

    //    if (airSegment[i].originTerminal != null && airSegment[i].originTerminal != "" && airSegment[i].originTerminal != undefined) {
    //      airSeg.originTerminal = airSegment[i].originTerminal;
    //    }
    //    if (airSegment[i].destinationTerminal != null && airSegment[i].destinationTerminal != "" && airSegment[i].destinationTerminal != undefined) {
    //      airSeg.destinationTerminal = airSegment[i].destinationTerminal;
    //    }
    //  }
    //  else {

    //    let dptDate = airSegment[i].departureTime;



    //    let stopDepTime = airSegment[i].departureTime;
    //    let departPipe: DatePipe = new DatePipe('en-US');
    //    if (stopDepTime.length >= 16) {
          
    //      stopDepTime = stopDepTime.split('T')[0];
    //      airSeg.depatureDateTime = (departPipe.transform(stopDepTime, "EEE,MMM d, y")) + "," + airSegment[i].departureTime.slice(11, 16);
    //    }

    //    else
    //      airSeg.depatureDateTime = stopDepTime;

    //    let stopArrivTime = airSegment[i].arrivalTime;
    //    let arrivePipe: DatePipe = new DatePipe('en-US');

    //    if (stopArrivTime.length >= 16) {
    //      stopArrivTime = stopArrivTime.split('T')[0];
    //      airSeg.arrivalDateTime = (arrivePipe.transform(stopArrivTime, "EEE,MMM d, y")) + "," + airSegment[i].arrivalTime.slice(11, 16);
    //    }
    //    else
    //      airSeg.arrivalDateTime = stopArrivTime;
    //  }




    //  airSeg.carrier = airSegment[i].carrier;
    //  if (this.bookingBaseData.supplierCode == "1G" || this.bookingBaseData.supplierCode == "6E") {
    //    if (airSegment[i].flightDetails != null) {
    //      if (airSegment[i].flightDetails[0].originTerminal != null && airSegment[i].flightDetails[0].originTerminal != "" && airSegment[i].flightDetails[0].originTerminal != undefined) {
    //        airSeg.originTerminal = airSegment[i].flightDetails[0].originTerminal;
    //      }
    //      if (airSegment[i].flightDetails[0].destinationTerminal != null && airSegment[i].flightDetails[0].destinationTerminal != "" && airSegment[i].flightDetails[0].destinationTerminal != undefined) {
    //        airSeg.destinationTerminal = airSegment[i].flightDetails[0].destinationTerminal;
    //      }
    //    }
    //  }
    //  else if (this.bookingBaseData.supplierCode == "FZ" || this.bookingBaseData.supplierCode == "J9") {
    //    if (airSegment[i].originTerminal != null && airSegment[i].originTerminal != "" && airSegment[i].originTerminal != undefined) {
    //      airSeg.originTerminal = airSegment[i].originTerminal;
    //    }
    //    if (airSegment[i].destinationTerminal != null && airSegment[i].destinationTerminal != "" && airSegment[i].destinationTerminal != undefined) {
    //      airSeg.destinationTerminal = airSegment[i].destinationTerminal;
    //    }

    //  }


    //  airSeg.flightNumber = airSegment[i].flightNumber;

    //  airSeg.classOfService = airSegment[i].classOfService;



    //  airSeg.flightTime = airSegment[i].flightTime;
    //  if (airSeg.flightTime.includes("h") || airSeg.flightTime.includes("m")) {
    //    airSeg.flightTime = airSeg.flightTime;
    //  }
    //  else {

    //    let flHours = (Math.floor(Number(airSeg.flightTime) / 60)).toString();

    //    let flMinutes = (Number(airSeg.flightTime) % 60).toString();

    //    airSeg.flightTime = flHours + "h" + " " + flMinutes + "m";
    //  }



    //  airSeg.fromCity = airSegment[i].origin;

    //  airSeg.toCity = airSegment[i].destination;


    //  if (airSegment.length == 1) {
    //    airSeg.fromTerminal = flightProp.flightLocationInfo[i].fromAirport;

    //    airSeg.toTerminal = flightProp.flightLocationInfo[i].toAirport;
    //  }

    //  this.airSegmentDetails.push(airSeg);

    //}


    let airPricingSolution: PassengerFares[] = [];

    airPricingSolution = this.bookingInfo.passengerFares;

    let completeprofit = 0;

   // if (this.bookingBaseData.extraProfit == undefined)

   // this.bookingBaseData.extraProfit = 0;

    this.currency = airPricingSolution[0].agencyBaseFareAmount.substring(0, 3);
    this.currencyRate = airPricingSolution[0].currencyRate;
    this.currencyRateJ = airPricingSolution[0].jazCRate;
    for (let i = 0; i < airPricingSolution.length; i++) {

     

      let priceCard = new PriceCardDetails();

      priceCard.passengerType = String(airPricingSolution[i].passengerType);





      if (priceCard.passengerType == "1") {

        priceCard.passengerType = "Adult";

        //this.extraprofit = this.bookingBaseData.extraProfit *(this.bookingBaseData.flightProp.adult);

        priceCard.passengerCount = airPricingSolution[i].count;

      }

      else if (priceCard.passengerType == "2") {

        priceCard.passengerType = "Child";

        //this.extraprofit = this.bookingBaseData.extraProfit *(this.bookingBaseData.flightProp.child);

        priceCard.passengerCount = airPricingSolution[i].count;

      }

      else if (priceCard.passengerType == "3") {

        priceCard.passengerType = "Infant";

        //this.extraprofit = this.bookingBaseData.extraProfit *(this.bookingBaseData.flightProp.infant);

        priceCard.passengerCount = airPricingSolution[i].count;

      }
  // else {
        priceCard.indivisualBasePrice = airPricingSolution[i].baseFareAmount;
        priceCard.agencyBasePrice = airPricingSolution[i].agencyBaseFareAmount;
      priceCard.indivisualTaxes = this.currency + (Number(airPricingSolution[i].taxAmount.substring(3))).toFixed(2);
      if (this.bookingInfo.groupTicketId > 0) {
          priceCard.agencyTaxes = this.currency + (Number(airPricingSolution[i].agencyTaxAmount.substring(3)) + Number(airPricingSolution[i].gruoupTicketServiceCharges.substring(3)));
        }
        else {
          priceCard.agencyTaxes = airPricingSolution[i].agencyTaxAmount;

        }
        priceCard.indivisualTotalPrice = airPricingSolution[i].totalAmount;
        priceCard.agencyTotalPrice = airPricingSolution[i].agencyTotalPrice;
        priceCard.serviceFee = airPricingSolution[i].serviceFee;
        priceCard.agencyServiceFee = airPricingSolution[i].agencyServiceFee;
        priceCard.discount = airPricingSolution[i].discount;
        priceCard.agencyDiscount = airPricingSolution[i].agencyDiscount;
        priceCard.currencyRate = this.currencyRate;
        priceCard.jazCRate = this.currencyRateJ;
        priceCard.seatFee = this.currency + "0";
        priceCard.mealFee = this.currency + "0";
        priceCard.baggageFee = this.currency + "0";
        this.totalANCIConv = this.currency + "0";
     // }



      //completeprofit += this.extraprofit;

      this.totalBasePrice += Number(airPricingSolution[i].agencyBaseFareAmount.substring(3));
      this.totalServiceFee += Number(airPricingSolution[i].agencyServiceFee.substring(3));
      if (airPricingSolution[i].agencyDiscount != null && airPricingSolution[i].agencyDiscount != undefined) {
        this.totalDiscount += Number(airPricingSolution[i].agencyDiscount.substring(3));
      }
      else {
        this.totalDiscount = 0
      }



      if ((this.bookingInfo.providerCode == "1G" || this.bookingInfo.providerCode == "6E" || this.bookingInfo.providerCode == "G9" || this.bookingInfo.providerCode == "PA" || this.bookingInfo.providerCode == "9P" || this.bookingInfo.providerCode == "3L") && flightProp.tripType == "multi") {

        this.totalTaxes += (Number(airPricingSolution[i].agencyTaxAmount.substring(3)) /*+ this.extraprofit*/);
        this.totalPrice += (Number(airPricingSolution[i].agencyTotalPrice.substring(3)) /*+ this.extraprofit*/);
      }
      else {

        if (this.bookingInfo.groupTicketId > 0) {
          this.totalTaxes += ((Number(airPricingSolution[i].agencyTaxAmount.substring(3))) + (Number(airPricingSolution[i].gruoupTicketServiceCharges.substring(3))));
        }
        else {
          this.totalTaxes += (Number(airPricingSolution[i].agencyTaxAmount.substring(3)));

        }



        this.totalPrice += (Number(airPricingSolution[i].agencyTotalPrice.substring(3)));
      }
      this.priceCardDetails.push(priceCard);



    }    //}

    this.totalBasePriceConv = this.currency + this.totalBasePrice.toFixed(2);

    this.totalTaxesConv = this.currency + this.totalTaxes.toFixed(2);

    this.totalPriceConv = this.currency + this.totalPrice.toFixed(2);
    this.totalDiscountConv = this.currency + this.totalDiscount.toFixed(2);

    this.totalServiceFeeConv = this.currency + this.totalServiceFee.toFixed(2);

  }
  seatsSectionClose() {

    var close = document.querySelector(".seat-anxi") as HTMLDivElement;
    close.classList.add("hid-seats");

  }

  seatsRemSectionClose() {
    var close = document.querySelector(".seat-rem-anxi") as HTMLDivElement;
    close.classList.add("hid-rem-seats");
  }

  removeAnxiClose() {
    var close = document.querySelector(".rm-anxi") as HTMLDivElement;
    close.classList.add("rrrm-anxi");
  }
  removeAddAnxiClose() {
    var hid = document.querySelector('.hhh') as HTMLDivElement;
    hid.classList.add("hid-anxi");
  }

  removeModifyClose() {
    this.AddPax = false;
    this.bookingInfo.exchangebookingPassengerInfoProperties = [];
    //var hid = document.querySelector('.tttt') as HTMLDivElement;
    //hid.classList.add("adpxV");
  }
  //ConfirmPriceofPassengerFZ() {
  //  this.bookingInfo.supplierAirPricingSolution = this.updatePassengerObj.priceDetails;
  //  this.bookingInfo.passengerFares = this.updatePassengerObj.passengerFares;
  //  this.flightService.ConfirmAddPassengerBooking(this.bookingInfo).subscribe((data) => {
  //    //this.isLoadPanelVisible = false;
  //    if (data.isSaved) {
  //        var bookingid = data.bookingID;
  //        localStorage.setItem("bookingID", String(bookingid));
  //        this.router.navigateByUrl('/ticket-issuance');
  //        //this.flyDubaiAnxillaryProcessing(data);

  //      }
  //    });
  //}
  //CancelpriceFZ() {
  //  this.ConfirmationPrice = false;
  //}
}
